/**
 * BirFlyPermit — Hindi strings, written in natural Devanagari (not transliterated English).
 * Typed as `Record<keyof typeof en, string>` so a missing or extra key is a compile error.
 */
import { en } from './en';

export const hi: Record<keyof typeof en, string> = {
  // ── Navigation ─────────────────────────────────────────────────────────
  'nav.home': 'होम',
  'nav.register': 'पंजीकरण करें',
  'nav.status': 'स्थिति जांचें',
  'nav.verify': 'कार्ड सत्यापित करें',
  'nav.office': 'कार्यालय',
  'nav.stats': 'आँकड़े',
  'nav.menu': 'मेनू',
  'nav.about': 'हमारे बारे में',
  'nav.staffSignIn': 'स्टाफ़ साइन इन',
  'nav.primaryAria': 'मुख्य',
  'nav.footerAria': 'फ़ुटर',
  'nav.skipToContent': 'सामग्री पर जाएं',
  'footer.privacyNotice': 'गोपनीयता सूचना',

  // ── Form steps ─────────────────────────────────────────────────────────
  'steps.who.title': 'आप कौन हैं',
  'steps.who.help': 'आपका व्यक्तिगत और संपर्क विवरण',
  'steps.photo.title': 'आपकी फ़ोटो',
  'steps.photo.help': 'आपके फ्री फ़्लायर कार्ड के लिए एक स्पष्ट, हाल की फ़ोटो',
  'steps.documents.title': 'आपके दस्तावेज़',
  'steps.documents.help': 'पासपोर्ट या भारतीय पहचान पत्र, और विदेशी नागरिक होने पर वीज़ा विवरण',
  'steps.equipment.title': 'आपका उपकरण',
  'steps.equipment.help': 'ग्लाइडर, रिज़र्व पैराशूट और प्रमाणन विवरण',
  'steps.equipment.certification': 'फ्लाइंग लाइसेंस / प्रमाणन',
  'steps.equipment.reserveOptional': 'रिज़र्व पैराशूट (वैकल्पिक)',
  'steps.safety.title': 'सुरक्षा और आपातकाल',
  'steps.safety.help': 'बीमा और एक आपातकालीन संपर्क',
  'steps.declaration.title': 'घोषणा और बॉन्ड',
  'steps.declaration.help': 'घोषणा और क्षतिपूर्ति बॉन्ड पढ़ें और स्वीकार करें',

  // ── Field labels ─────────────────────────────────────────────────────────
  'field.givenNames': 'प्रथम नाम',
  'field.surname': 'उपनाम / सरनेम',
  'field.fathersName': 'पिता / माता का नाम',
  'field.addressLine': 'पता',
  'field.city': 'शहर / कस्बा',
  'field.region': 'राज्य / क्षेत्र',
  'field.country': 'निवास देश',
  'field.postcode': 'पिन कोड',
  'field.nationality': 'राष्ट्रीयता',
  'field.dob': 'आपकी जन्म तिथि',
  'field.phone': 'फ़ोन नंबर',
  'field.email': 'ईमेल पता',
  'field.docType': 'पहचान दस्तावेज़ का प्रकार',
  'field.docNumber': 'दस्तावेज़ संख्या',
  'field.docIssuingCountry': 'जारीकर्ता देश',
  'field.docExpiry': 'दस्तावेज़ की समाप्ति तिथि',
  'field.mrzLine1': 'एमआरज़ेड पंक्ति 1',
  'field.mrzLine2': 'एमआरज़ेड पंक्ति 2',
  'field.isForeign': 'विदेशी नागरिक',
  'field.arrivalDate': 'भारत आगमन तिथि',
  'field.visaType': 'वीज़ा प्रकार',
  'field.visaValidFrom': 'वीज़ा प्रारंभ तिथि',
  'field.visaValidTo': 'वीज़ा समाप्ति तिथि',
  'field.certBody': 'प्रमाणन संस्था',
  'field.certLevel': 'प्रमाणन स्तर',
  'field.certNumber': 'प्रमाणपत्र संख्या',
  'field.certIssued': 'प्रमाणपत्र जारी होने की तिथि',
  'field.certExpiry': 'प्रमाणपत्र समाप्ति तिथि',
  'field.certHolderName': 'प्रमाणपत्र पर नाम',
  'field.gliderModel': 'पैराग्लाइडर मॉडल',
  'field.gliderClass': 'ग्लाइडर श्रेणी (EN रेटिंग)',
  'field.reserveMake': 'रिज़र्व पैराशूट निर्माता',
  'field.reserveModel': 'रिज़र्व पैराशूट मॉडल',
  'field.reserveRepack': 'रिज़र्व पैराशूट की अंतिम पैकिंग तिथि',
  'field.insProvider': 'बीमा प्रदाता',
  'field.insPolicyNo': 'बीमा पॉलिसी संख्या',
  'field.insInsuredName': 'बीमा पॉलिसी पर नाम',
  'field.insCoverText': 'बीमा कवर का विवरण',
  'field.insValidTo': 'बीमा समाप्ति तिथि',
  'field.emgName': 'आपातकालीन संपर्क का नाम',
  'field.emgRelationship': 'आपातकालीन संपर्क से रिश्ता',
  'field.emgPhone': 'आपातकालीन संपर्क फ़ोन नंबर',
  'field.bloodGroup': 'रक्त समूह',
  'field.stayFrom': 'बीर में ठहराव की पहली तारीख',
  'field.stayTo': 'अंतिम तारीख',
  'field.stayPlace': 'बीर में आप कहाँ ठहरे हैं?',
  'field.stayArea': 'ठहरने का गाँव / क्षेत्र',
  'field.radioFrequency': 'रेडियो फ़्रीक्वेंसी (सुरक्षा और बचाव)',
  'field.declarationAccepted': 'घोषणाएँ',
  'field.bondAccepted': 'क्षतिपूर्ति बॉन्ड',
  'field.typedName': 'हस्ताक्षर के लिए अपना पूरा नाम टाइप करें',
  'field.consentPurpose': 'मैं ऊपर बताए अनुसार अपने डेटा के उपयोग के लिए सहमति देता/देती हूँ',

  // ── Declaration clauses ────────────────────────────────────────────────
  'declaration.clause1': 'मैं शारीरिक और मानसिक रूप से पूर्णतः स्वस्थ हूँ।',
  'declaration.clause2': 'मैं हिमालयी परिस्थितियों में पैराग्लाइडिंग के खेल की प्रकृति और इसमें निहित जोखिम को समझता/समझती हूँ।',
  'declaration.clause3':
    'मैं अपने जोखिम पर उड़ान भरना चुनता/चुनती हूँ और हिमाचल प्रदेश सरकार प्रशासन तथा इसकी नियुक्त समितियों एवं सहायक स्थानीय निकायों को किसी भी दायित्व से मुक्त करता/करती हूँ।',
  'declaration.clause4':
    'मैं आगे यह समझता/समझती हूँ और घोषणा करता/करती हूँ कि किसी दुर्घटना, खोज एवं बचाव तथा चिकित्सा उपचार की स्थिति में यह मेरे अपने खर्च पर होगा।',

  // ── क्षतिपूर्ति बॉन्ड की धाराएँ I–VIII (कार्यालय के छपे INDEMNITY BOND का हिंदी रूप; VIII समीक्षक द्वारा जोड़ी गई) ──
  'bond.clause1':
    'मुझे बताया गया है और मैं जानता/जानती हूँ कि पैराग्लाइडिंग खतरनाक हो सकती है और इसमें अनेक जोखिम और खतरे हैं, जिनमें पैराग्लाइडर से यात्रा के खतरे, चिकित्सा सुविधाओं से दूर दुर्गम स्थानों पर दुर्घटना या बीमारी, प्रकृति की शक्तियाँ, दैवी आपदा, चरम मौसम, ऐसा शारीरिक श्रम जिसके लिए मैं तैयार न होऊँ, और चोट या अक्षमता की स्थिति में निकासी की कठिनाइयाँ शामिल हैं, पर ये इन्हीं तक सीमित नहीं हैं। मुझे इन और अन्य अंतर्निहित जोखिमों की जानकारी है, और मैं स्वीकार करता/करती हूँ कि घर और काम की सामान्य सुरक्षा से परे रोमांच का आनंद ही आंशिक रूप से मेरी भागीदारी का कारण है।',
  'bond.clause2':
    'मैं एतद्द्वारा संचालक, हिमाचल प्रदेश सरकार, को मेरे, मेरे व्यक्तिगत प्रतिनिधियों, उत्तराधिकारियों, समनुदेशितियों और निकट संबंधियों के प्रति हर प्रकार की हानि, क्षति या चोट, अथवा मेरे शरीर या संपत्ति को चोट या मेरी मृत्यु के कारण किसी भी दावे या माँग से — चाहे वह संचालक या अन्य किसी की लापरवाही सहित किसी भी कारण से हो — जब मैं रोमांच गतिविधि में भाग ले रहा/रही हूँ, मुक्त करता/करती हूँ, छूट देता/देती हूँ, क्षतिपूर्ति का वचन देता/देती हूँ और मुकदमा न करने पर सहमत हूँ। मैं आगे सहमत हूँ कि मैं जोखिम स्वयं उठाऊँगा/उठाऊँगी और चोट या दुर्घटना की किसी भी स्थिति में उचित बचाव कार्य प्राप्त या संचालित करने में किसी भी विफलता — जिसमें पर्याप्त चिकित्सा सेवाएँ प्राप्त करने, निकासी करने, या उपचार, दवा या प्रशिक्षित बचाव कर्मी उपलब्ध कराने में विफलता शामिल है — के कारण मेरे शरीर या संपत्ति को चोट या मेरी मृत्यु के किसी भी दायित्व से संचालक को मुक्त करता/करती हूँ।',
  'bond.clause3': 'मैं आगे सहमत हूँ कि दुर्घटना या आपात स्थिति में बचाव या चिकित्सा देखभाल पर होने वाला कोई भी व्यय राज्य सरकार वहन नहीं करेगी।',
  'bond.clause4':
    'मैं स्पष्ट रूप से स्वीकार करता/करती हूँ और सहमत हूँ कि रोमांच यात्रा, जिसमें वह यात्रा भी शामिल है जिसमें मैं भाग ले रहा/रही हूँ, खतरनाक हो सकती है और इसमें गंभीर एवं अभूतपूर्व शारीरिक चोट, संपत्ति की क्षति और मृत्यु शामिल है, और मेरा आशय है कि संचालक के प्रति उपर्युक्त छूट और मुक्ति उतनी व्यापक और समावेशी हो जितनी कानून अनुमति देता है। मैं सुरक्षा के संबंध में संचालक के किसी मौखिक या लिखित प्रतिनिधित्व या कथन पर निर्भर नहीं हूँ, और यह समझौता अपनी स्वतंत्र इच्छा से कर रहा/रही हूँ।',
  'bond.clause5': 'मैं आगे सहमत हूँ कि पैराग्लाइडिंग यात्रा में भाग लेते समय मेरे पास शराब या अवैध नशीले पदार्थ नहीं होंगे।',
  'bond.clause6': 'मैंने इस दायित्व और जोखिम-स्वीकृति की सभी शर्तें पढ़ और समझ ली हैं और अपनी स्वतंत्र इच्छा से, बिना किसी आपत्ति के, उनसे सहमत हूँ।',
  'bond.clause7': 'मैं आगे सहमत हूँ कि मैं मैक्लॉडगंज (ऊपरी धर्मशाला) में परम पावन दलाई लामा के निवास के ऊपर उड़ान नहीं भरूँगा/भरूँगी।',
  'bond.clause8':
    'मैं आगे सहमत हूँ कि मैं निम्न क्षेत्रों के ऊपर या उनके निकट उड़ान नहीं भरूँगा/भरूँगी: (1) अलहिलाल, योल और होल्टा के सैन्य (आर्मी) क्षेत्र; (2) डलहौज़ी का वायु सेना रडार; (3) भुंतर स्थित कुल्लू हवाई अड्डा और उसके आसपास का क्षेत्र।',

  // ── Application status ─────────────────────────────────────────────────
  'status.Submitted': 'प्राप्त हुआ — समीक्षा की प्रतीक्षा में',
  'status.Validated': 'जांच पूर्ण — मूल्यांकन हेतु प्रतीक्षा में',
  'status.CorrectionRequested': 'सुधार आवश्यक — कृपया मांगी गई जानकारी सुधारकर भेजें',
  'status.ReadyForEvaluation': 'मूल्यांकन की कतार में',
  'status.Evaluated': 'मूल्यांकन हो चुका — सिफ़ारिश की प्रतीक्षा',
  'status.EvaluationFailed': 'मूल्यांकन में उत्तीर्ण नहीं — कार्यालय समीक्षा में',
  'status.UnderReview': 'एसडीएम कार्यालय में समीक्षाधीन',
  'status.PaymentPending': 'स्वीकृत — परमिट शुल्क देय',
  'status.Approved': 'स्वीकृत — आपका कार्ड जारी किया जा रहा है',
  'status.CardIssued': 'आपका फ्री फ़्लायर कार्ड जारी कर दिया गया है',
  'status.Rejected': 'आवेदन स्वीकृत नहीं हुआ',
  'status.Revoked': 'कार्ड निरस्त कर दिया गया',
  'status.Expired': 'कार्ड की अवधि समाप्त',
  'status.greeting': 'नमस्ते, {name}',

  // ── Verdict strings ────────────────────────────────────────────────────
  'verdict.valid': 'मान्य',
  'verdict.validExpiresToday': 'मान्य — आज समाप्त हो रहा है',
  'verdict.staleList': 'मान्य — निरस्तीकरण सूची {hours} घंटे पुरानी है',
  'verdict.notYetValid': 'अभी मान्य नहीं',
  'verdict.expired': 'समाप्त',
  'verdict.revoked': 'निरस्त',
  'verdict.signatureInvalid': 'हस्ताक्षर अमान्य — कार्ड में बदलाव या जालसाज़ी',
  'verdict.unknownKey': 'अज्ञात हस्ताक्षर कुंजी',
  'verdict.invalidCard': 'अमान्य कार्ड',

  // ── Common buttons ─────────────────────────────────────────────────────
  'button.next': 'अगला',
  'button.back': 'पीछे',
  'button.submit': 'जमा करें',
  'button.retry': 'पुनः प्रयास करें',
  'button.save': 'सहेजें',
  'button.continueOffline': 'ऑफ़लाइन जारी रखें',
  'button.confirm': 'पुष्टि करें',
  'button.cancel': 'रद्द करें',
  'button.close': 'बंद करें',
  'button.download': 'डाउनलोड करें',
  'button.print': 'प्रिंट करें',
  'button.upload': 'अपलोड करें',
  'button.edit': 'संपादित करें',
  'button.delete': 'हटाएं',

  // ── Errors ─────────────────────────────────────────────────────────────
  'error.network': 'नेटवर्क त्रुटि — कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।',
  'error.validation': 'कृपया हाइलाइट किए गए फ़ील्ड ठीक करें।',
  'error.fixBefore': 'जमा करने से पहले:',
  'error.typedNameRequired': 'हस्ताक्षर के लिए अपना पूरा नाम टाइप करें।',
  'error.typedNameMismatch': 'यह चरण 1 में दर्ज नाम ({name}) से मेल नहीं खाता। उसे उसी तरह टाइप करें।',
  'error.declarationClauses': 'घोषणा के सभी {n} बिंदुओं पर टिक करें।',
  'error.bondClauses': 'क्षतिपूर्ति बॉन्ड के सभी {n} बिंदुओं पर टिक करें।',
  'error.consent': 'डेटा-उपयोग सहमति पर टिक करें।',
  'error.stepIncomplete': 'चरण {n} ({title}) अधूरा है।',
  'photo.check.retake': 'यह फ़ोटो इस्तेमाल नहीं हो सकती — आगे बढ़ने से पहले दोबारा लें।',
  'error.unauthorized': 'कृपया दोबारा लॉग इन करें।',
  'error.forbidden': 'आपको यह करने की अनुमति नहीं है।',
  'error.notFound': 'नहीं मिला।',
  'error.conflict': 'यह रिकॉर्ड कहीं और बदल दिया गया है — कृपया पुनः लोड करके प्रयास करें।',
  'error.rateLimited': 'बहुत अधिक अनुरोध — कृपया कुछ देर रुककर पुनः प्रयास करें।',
  'error.internal': 'हमारी ओर से कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें।',
  'error.tryAgain': 'पुनः प्रयास करें',

  // ── DPDP purpose/consent statement ────────────────────────────────────────
  'consent.purpose':
    'आपकी जानकारी केवल आपको एक पायलट के रूप में पंजीकृत करने और उप-मंडल अधिकारी (एसडीएम) के अधिकार के तहत फ्री फ़्लायर कार्ड जारी करने के लिए एकत्र की जाती है। इसे {years} वर्षों तक सुरक्षित रखा जाता है और शिकायत अधिकारी से संपर्क करके इसे ठीक कराया या इसके बारे में पूछा जा सकता है।',

  // ── Field hints ────────────────────────────────────────────────────────────
  'hint.givenNames': 'ठीक वैसे ही जैसे आपके पहचान दस्तावेज़ पर छपा है।',
  'hint.surname': 'ठीक वैसे ही जैसे आपके पहचान दस्तावेज़ पर छपा है।',
  'hint.fathersName': 'किसी एक अभिभावक का नाम, जैसा आपके दस्तावेज़ पर है। वैकल्पिक।',
  'hint.addressLine': 'आपका स्थायी पता, रजिस्टर के लिए और आवश्यकता पड़ने पर संपर्क के लिए।',
  'hint.city': 'आपके स्थायी पते का शहर या कस्बा।',
  'hint.region': 'आपके स्थायी पते का राज्य या क्षेत्र।',
  'hint.country': 'आपके स्थायी पते का देश।',
  'hint.postcode': 'आपके स्थायी पते का पिन कोड।',
  'hint.nationality': 'यह तय करता है कि वीज़ा फ़ील्ड ज़रूरी हैं या नहीं और आपके नाम की जांच कैसे होगी।',
  'hint.dob': 'उड़ान के लिए उचित आयु और आपके दस्तावेज़ से मिलान के लिए जांचा जाता है।',
  'hint.phone': 'ताकि कार्यालय आपके आवेदन के बारे में आपसे संपर्क कर सके। अपना देश कोड शामिल करें।',
  'hint.email': 'वैकल्पिक, लेकिन आपको स्थिति लिंक और पावती ईमेल पर मिलेगी।',
  'hint.docType': 'विदेशी नागरिकों को पासपोर्ट का उपयोग करना होगा; भारतीय नागरिक किसी भी सूचीबद्ध पहचान पत्र का उपयोग कर सकते हैं।',
  'hint.docNumber': 'ठीक वैसा ही जैसा आपके दस्तावेज़ पर छपा है।',
  'hint.docIssuingCountry': 'वह देश जिसने आपका दस्तावेज़ जारी किया।',
  'hint.docExpiry': 'कार्ड अवधि के अंत तक मान्य रहना चाहिए।',
  'hint.isForeign': 'विदेशी नागरिकों से वीज़ा के बारे में कुछ अतिरिक्त प्रश्न पूछे जाते हैं।',
  'hint.arrivalDate': 'यह पुष्टि करने के लिए कि आपका वीज़ा आपके प्रवास को कवर करता है।',
  'hint.visaType': 'जिस प्रकार के वीज़ा पर आप भारत आए।',
  'hint.visaValidFrom': 'पूरी कार्ड अवधि को कवर करना चाहिए।',
  'hint.visaValidTo': 'पूरी कार्ड अवधि को कवर करना चाहिए।',
  'hint.certBody': 'आपकी पैराग्लाइडिंग प्रमाणन संस्था।',
  'hint.certLevel': 'अधिकतम स्वीकृत ग्लाइडर श्रेणी तय करता है।',
  'hint.certNumber': 'जैसा आपके प्रमाणपत्र पर छपा है।',
  'hint.certIssued': 'आपका प्रमाणन जारी होने की तिथि।',
  'hint.certExpiry': 'समाप्त नहीं होना चाहिए।',
  'hint.certHolderName': 'आपके नाम से मिलान किया जाता है — नज़दीकी मेल होना चाहिए।',
  'hint.gliderModel': 'जैसे Ozone Rush 6, Advance Iota 3',
  'hint.gliderClass': 'EN या DHV सुरक्षा श्रेणी — आपके प्रमाणन स्तर से जांची जाती है।',
  'hint.reserveMake': 'सुरक्षा रिकॉर्ड के लिए आपका रिज़र्व पैराशूट।',
  'hint.reserveModel': 'सुरक्षा रिकॉर्ड के लिए आपका रिज़र्व पैराशूट।',
  'hint.reserveRepack': 'रिज़र्व को समय-समय पर दोबारा पैक किया जाना चाहिए — यह पुष्टि करने में मदद करता है कि यह उड़ान योग्य है।',
  'hint.insProvider': 'आपका यात्रा/साहसिक खेल बीमा प्रदाता।',
  'hint.insPolicyNo': 'जैसा आपकी पॉलिसी पर छपा है।',
  'hint.insInsuredName': 'आपके नाम से मिलान किया जाता है।',
  'hint.insCoverText': 'अपनी पॉलिसी की वह पंक्ति चिपकाएँ या टाइप करें जिसमें पैराग्लाइडिंग का उल्लेख है — हम जांचते हैं कि यह खेल को कवर करती है।',
  'hint.insValidTo': 'पूरी कार्ड अवधि को कवर करना चाहिए।',
  'hint.emgName': 'उड़ान के दौरान आपातकाल की स्थिति में हम जिससे संपर्क कर सकें।',
  'hint.emgRelationship': 'यह व्यक्ति आपसे किस प्रकार संबंधित है।',
  'hint.emgPhone': 'आपके अपने नंबर से अलग होना चाहिए।',
  'hint.bloodGroup': 'वैकल्पिक — आवश्यकता पड़ने पर केवल बचाव दल के साथ साझा किया जाता है।',
  'hint.stayFrom': 'आपकी पहली उड़ान का दिन। आपका कार्ड इस तारीख से वैध होगा (या जारी होने के दिन से, यदि वह बाद में हो)।',
  'hint.stayTo': 'बीर में आपका अंतिम दिन। आपका कार्ड इस तारीख तक वैध होगा। परमिट शुल्क ठहराव के हर 7 दिनों पर लगता है, और आपके दस्तावेज़ (वीज़ा, बीमा, पहचान) केवल इन्हीं दिनों को कवर करने चाहिए।',
  'stay.feeHint': 'इन तारीखों के लिए परमिट शुल्क: {text}',
  'hint.stayPlace': 'होटल, गेस्टहाउस, होमस्टे या कैंप का नाम — आपात स्थिति में बचाव दल इसी से आपको ढूँढता है।',
  'hint.stayArea': 'वैकल्पिक — जैसे बीर, चौगान, गुनेहड़, बिलिंग।',
  'hint.radioFrequency': 'वैकल्पिक — जिस फ़्रीक्वेंसी पर आप या आपका समूह सुनते हैं, जैसे 144.800 MHz। केवल आपात स्थिति में बचाव दल द्वारा उपयोग।',
  'hint.typedName': 'ऊपर दिए गए अनुसार अपना पूरा नाम ठीक-ठीक टाइप करें — यह आपका हस्ताक्षर है।',
  'hint.consentPurpose': 'आवेदन जमा करने के लिए आवश्यक।',

  // ── MRZ capture panel ──────────────────────────────────────────────────────

  // ── Photo capture ──────────────────────────────────────────────────────────
  'photo.capture.title': 'अपनी कार्ड फ़ोटो लें',
  'photo.capture.guide': 'कैमरे की ओर सीधे देखें, सादा पृष्ठभूमि, सिर और कंधे गाइड के अंदर हों।',
  'photo.capture.guidance': 'सादा, हल्की पृष्ठभूमि। कैमरे की ओर देखें, टोपी या धूप का चश्मा नहीं, सिर और कंधे रूपरेखा के अंदर हों।',
  'photo.capture.selfie': 'सेल्फ़ी लें',
  'photo.capture.gallery': 'गैलरी से चुनें',
  'photo.capture.button': 'फ़ोटो लें या चुनें',
  'photo.capture.retake': 'फिर से लें',
  'photo.capture.zoom': 'ज़ूम',
  'photo.capture.confirm': 'यह फ़ोटो उपयोग करें',
  'photo.capture.processing': 'फ़ोटो प्रोसेस हो रही है…',

  // ── File upload field labels ──────────────────────────────────────────────
  'upload.docLabel': 'पहचान दस्तावेज़ की फ़ोटो या फ़ाइल',
  'upload.certLabel': 'फ्लाइंग लाइसेंस की फ़ोटो या फ़ाइल',
  'upload.insLabel': 'बीमा पॉलिसी की फ़ोटो या फ़ाइल',
  'upload.photoLabel': 'कार्ड फ़ोटो',
  'upload.passportLabel': 'पासपोर्ट का फ़ोटो पृष्ठ',
  'upload.passportHint': 'वह पृष्ठ जिस पर आपकी फ़ोटो है। वीज़ा हो तो वीज़ा पृष्ठ भी जोड़ें।',
  'upload.insHint': 'पॉलिसी का हर पृष्ठ जोड़ें — कई फ़ोटो या एक PDF।',
  'upload.takePhoto': 'फ़ोटो लें',
  'camera.title': 'फ़ोटो लें',
  'camera.capture': 'खींचें',
  'camera.retake': 'फिर से लें',
  'camera.use': 'यह फ़ोटो उपयोग करें',
  'camera.switch': 'कैमरा बदलें',
  'camera.starting': 'कैमरा शुरू हो रहा है…',
  'camera.denied': 'कैमरा शुरू नहीं हो सका। ब्राउज़र में कैमरा की अनुमति दें, या फ़ाइल चुनें।',
  'camera.chooseInstead': 'इसके बजाय फ़ाइल चुनें',
  'upload.chooseFile': 'गैलरी / फ़ाइलों से चुनें',
  'upload.addAnother': 'एक और पृष्ठ जोड़ें',
  'upload.multiHint': 'आप कई फ़ोटो या एक PDF जोड़ सकते हैं — दस्तावेज़ का हर पृष्ठ जोड़ें।',
  'upload.pagesAdded': '{n} पृष्ठ जोड़े गए',
  'upload.pageOne': '1 पृष्ठ जोड़ा गया',
  'upload.page': 'पृष्ठ {n}',
  'upload.remove': 'पृष्ठ {n} हटाएँ',
  'upload.tooLarge': 'यह फ़ाइल बहुत बड़ी है (अधिकतम 1.4 MB)। इसके बजाय हर पृष्ठ की फ़ोटो लें।',
  'upload.unsupported': 'यह फ़ाइल प्रकार समर्थित नहीं है। फ़ोटो या PDF उपयोग करें।',

  // ── Document type / visa type options ───────────────────────────────────────
  'doc.type.passport': 'पासपोर्ट',
  'doc.type.aadhaar': 'आधार',
  'doc.type.voter_id': 'मतदाता पहचान पत्र',
  'doc.type.driving_licence': 'ड्राइविंग लाइसेंस',
  'doc.type.other': 'अन्य',
  'visa.type.eVisa': 'ई-वीज़ा',
  'visa.type.tourist': 'पर्यटक वीज़ा',
  'visa.type.other': 'अन्य',

  // ── Wizard chrome ─────────────────────────────────────────────────────────
  'wizard.progress': 'चरण {n} / {total}',
  'wizard.resume.title': 'अपना आवेदन जारी रखें?',
  'wizard.resume.body': 'हमें इस डिवाइस पर पहले शुरू किया गया एक आवेदन मिला। वहीं से जारी रखें जहाँ आपने छोड़ा था, या नया शुरू करें।',
  'wizard.resume.resume': 'जारी रखें',
  'wizard.resume.startOver': 'नया शुरू करें',
  'wizard.uploadedFile': 'अपलोड की गई: {name}',
  'wizard.requiredFile': 'यह दस्तावेज़ आवश्यक है।',
  'wizard.otherOption': 'अन्य',

  // ── Review step ──────────────────────────────────────────────────────────
  'review.title': 'अपना आवेदन जांचें',
  'review.edit': 'संपादित करें',
  'review.stay': 'ठहराव: {from} – {to} ({days} दिन)',
  'review.fee.title': 'परमिट शुल्क — कार्यालय की स्वीकृति के बाद देय',
  'review.fee.perWeek': '₹{unit} प्रति 7 दिन × {weeks} सप्ताह = ₹{amount}',
  'review.fee.flat': '₹{amount}',
  'review.fee.none': 'अभी कोई परमिट शुल्क नहीं लिया जा रहा है।',
  'review.fee.loading': 'गणना हो रही है…',
  'review.fee.after': 'भुगतान केवल स्वीकृति के बाद करना है — ई-मेल में भुगतान का विवरण होगा। भुगतान की पुष्टि होते ही कार्ड जारी किया जाता है।',
  'review.findingsTitle': 'प्रारंभिक जांच — कार्यालय इन्हें फिर से चलाता है',
  'review.amberNotice': 'आप अभी जमा कर सकते हैं, लेकिन कार्यालय आपसे इन्हें ठीक करने को कहेगा:',
  'review.readAll': 'मैंने ऊपर दी गई सभी शर्तें पढ़ ली हैं',
  'review.scrollHint': 'जारी रखने के लिए अंत तक स्क्रॉल करें।',

  // ── Submission ─────────────────────────────────────────────────────────────
  'submit.offline.title': 'सहेजा गया — ऑनलाइन होते ही भेजा जाएगा',
  'submit.offline.body': 'आप ऑफ़लाइन हैं। आपका आवेदन इस डिवाइस पर सहेजा गया है और कनेक्शन मिलते ही अपने आप भेज दिया जाएगा।',
  'submit.sending': 'आपका आवेदन भेजा जा रहा है…',
  'submit.success.title': 'आवेदन प्राप्त हुआ',
  'submit.success.reference': 'आपका संदर्भ',
  'submit.success.body': 'इस संदर्भ और नीचे दिए गए लिंक को सहेज लें — आपकी स्थिति जांचने के लिए इनकी आवश्यकता होगी।',
  'submit.success.mailNote': 'हमारे ई-मेल {from} से आते हैं। यदि कुछ मिनटों में ई-मेल न दिखे, तो Spam या Promotions में देखें और "Not spam" चिह्नित करें — फिर अगले ई-मेल (स्वीकृति, भुगतान, कार्ड) इनबॉक्स में आएँगे।',
  'submit.success.copyLink': 'स्थिति लिंक कॉपी करें',
  'submit.success.copied': 'कॉपी किया गया',
  'submit.success.shareLink': 'साझा करें',
  'submit.success.downloadPdf': 'पावती डाउनलोड करें (PDF)',
  'submit.success.viewStatus': 'मेरी स्थिति देखें',
  'submit.success.whatNext.title': 'आगे क्या होगा',
  'submit.success.whatNext.1': 'कार्यालय आपके दस्तावेज़ों और विवरणों की जांच करता है।',
  'submit.success.whatNext.2': 'एक मूल्यांकनकर्ता आपके प्रमाणन और उपकरण की समीक्षा करता है।',
  'submit.success.whatNext.3': 'एसडीएम स्वीकृति देते हैं और आपका फ्री फ़्लायर कार्ड जारी किया जाता है।',

  // ── Status page ─────────────────────────────────────────────────────────
  'status.page.title': 'आवेदन {ref}',
  'status.page.checkTitle': 'अपने आवेदन की स्थिति जांचें',
  'status.notFound.title': 'आवेदन नहीं मिला',
  'status.notFound.body': 'हमें इस लिंक से वह आवेदन नहीं मिला। संदर्भ और लिंक जांचकर पुनः प्रयास करें।',
  'status.offline.title': 'आप ऑफ़लाइन हैं',
  'status.offline.body': '{at} की अंतिम ज्ञात स्थिति दिखाई जा रही है।',
  'status.findings.title': 'जांच का सारांश',
  'status.correction.title': 'कार्रवाई आवश्यक',
  'status.correction.body': 'आपका आवेदन आगे बढ़ने से पहले कार्यालय ने निम्नलिखित मांगा है:',
  'status.correction.submit': 'सुधार जमा करें',
  'status.correction.sent': 'सुधार भेज दिया गया — धन्यवाद।',
  'status.card.title': 'आपका फ्री फ़्लायर कार्ड',
  'payment.title': 'परमिट शुल्क',
  'payment.amount': 'राशि',
  'payment.breakdown': '₹{unit} प्रति 7 दिन × {weeks} सप्ताह',
  'payment.office.title': 'भुगतान कैसे करें',
  'payment.office.after': 'भुगतान करते समय अपना संदर्भ बताएँ, फिर नीचे रसीद या लेन-देन संख्या रिपोर्ट करें।',
  'status.stay': 'बीर में आपका ठहराव',
  'status.stayDates': '{from} – {to}',
  'payment.dueBy': 'इस तारीख तक भुगतान करें',
  'payment.status.pending': 'अभी भुगतान नहीं हुआ',
  'payment.status.claimed': 'आपने रिपोर्ट किया — कार्यालय की पुष्टि प्रतीक्षित',
  'payment.status.paid': 'भुगतान हो गया',
  'payment.status.waived': 'कार्यालय द्वारा माफ़',
  'payment.status.expired': 'भुगतान लिंक समाप्त हो गया — कार्यालय से नया लिंक माँगें',
  'payment.payNow': '₹{amount} सुरक्षित रूप से भुगतान करें',
  'payment.payNowHint': 'सुरक्षित Razorpay पेज पर UPI, भारतीय और अंतर्राष्ट्रीय कार्ड स्वीकार्य हैं। भुगतान के बाद आप यहीं वापस आ जाएँगे।',
  'payment.checkAgain': 'भुगतान स्थिति जाँचें',
  'payment.upToDate': 'स्थिति अद्यतित है।',
  'payment.upi.title': 'UPI से भुगतान करें',
  'payment.upi.open': 'मेरा UPI ऐप खोलें',
  'payment.upi.vpa': 'UPI आईडी',
  'payment.upi.payee': 'प्राप्तकर्ता',
  'payment.upi.hint': 'फ़ोन पर बटन दबाएँ; कंप्यूटर पर किसी भी UPI ऐप से QR स्कैन करें। ठीक ₹{amount} का भुगतान संदर्भ {ref} के साथ करें, फिर नीचे UTR रिपोर्ट करें।',
  'payment.upi.foreignHint': 'UPI के लिए भारतीय बैंक खाता चाहिए। यदि आप UPI से भुगतान नहीं कर सकते, तो कार्यालय से संपर्क करें: {phone}।',
  'payment.claim.title': 'बताइए कि आपने भुगतान कर दिया है',
  'payment.claim.reference': 'UTR / लेन-देन आईडी',
  'payment.claim.referenceHint': 'UTR या लेन-देन आईडी — ज़्यादातर UPI ऐप में 12 अंकों की। स्क्रीनशॉट जोड़ें तो वैकल्पिक।',
  'payment.claim.note': 'टिप्पणी (वैकल्पिक)',
  'payment.claim.screenshot': 'भुगतान का स्क्रीनशॉट',
  'payment.claim.submit': 'भुगतान रिपोर्ट करें',
  'payment.claim.done': 'धन्यवाद — कार्यालय आपके भुगतान की पुष्टि करके आपका कार्ड जारी करेगा।',
  'payment.callback.verifying': 'गेटवे से आपके भुगतान की पुष्टि हो रही है…',
  'payment.callback.failed': 'अभी भुगतान की स्वतः पुष्टि नहीं हो सकी। एक मिनट बाद "भुगतान स्थिति जाँचें" दबाएँ, या नीचे रिपोर्ट करें।',
  'payment.receipt': 'भुगतान संदर्भ',
  'payment.paidAt': 'भुगतान तिथि',
  'case.payment.title': 'परमिट शुल्क',
  'case.payment.route': 'मार्ग',
  'case.payment.route.upi': 'कार्यालय खाते में UPI (अधिकारी पुष्टि करता है)',
  'case.payment.route.office': 'कार्यालय में / बैंक ट्रांसफ़र (अधिकारी पुष्टि करता है)',
  'case.payment.route.razorpay': 'Razorpay भुगतान लिंक',
  'case.payment.claim': 'पायलट ने रिपोर्ट किया',
  'case.payment.claimNote': 'पायलट की टिप्पणी',
  'case.payment.screenshot': 'स्क्रीनशॉट देखें',
  'case.payment.link': 'भुगतान लिंक',
  'case.payment.refresh': 'गेटवे से जाँचें',
  'case.payment.confirmedBy': 'पुष्टि की',
  'case.payment.sent': 'भुगतान ई-मेल भेजा गया',
  'case.payment.times': '{n} बार',
  'payment.ways.title': 'भुगतान के तरीके',
  'payment.ways.amountDue': 'देय राशि: ₹{amount}',
  'payment.ways.remark': 'भुगतान के रिमार्क / नोट में अपना आवेदन संदर्भ {ref} ज़रूर लिखें, ताकि कार्यालय आपका भुगतान पहचान सके।',
  'payment.ways.intro': 'नीचे दिए तरीकों में से कोई एक चुनें — राशि सभी के लिए समान है।',
  'payment.ways.option.upi': 'UPI से स्कैन करके भुगतान करें',
  'payment.ways.option.bank': 'बैंक ट्रांसफ़र (NEFT / IMPS)',
  'payment.ways.option.cash': 'कार्यालय काउंटर पर नक़द',
  'payment.ways.then': 'UPI या बैंक ट्रांसफ़र से भुगतान किया? नीचे हमें बताएँ ताकि कार्यालय अपने खाते में उसका मिलान कर सके। काउंटर पर नक़द दिया? काउंटर उसे दर्ज करता है; आप चाहें तो नीचे रसीद संख्या भी लिख सकते हैं।',
  'payment.upi.official': 'कार्यालय का अपना बैंक-जारी QR ({payee}), जिसमें राशि और आपका संदर्भ पहले से भरा है। GPay, PhonePe, Paytm, BHIM और हर UPI ऐप में काम करता है।',
  'payment.upi.generic': 'किसी भी UPI ऐप (GPay, PhonePe, Paytm, BHIM) से स्कैन करें; राशि और आपका संदर्भ पहले से भरा है।',
  'payment.upi.openHint': 'फ़ोन पर यह बटन आपका UPI ऐप खोलता है, जिसमें प्राप्तकर्ता, राशि और संदर्भ पहले से भरे होते हैं।',
  'payment.bank.hint': 'किसी भी भारतीय बैंक खाते से NEFT या IMPS द्वारा भेजें। विदेश से अपने बैंक को इस खाते में ट्रांसफ़र के लिए कहें और कुछ कार्य-दिवस का समय दें।',
  'payment.cash.where': 'यहाँ भुगतान करें',
  'payment.cash.phone': 'फ़ोन',
  'payment.cash.instructions': 'काउंटर समय और निर्देश',
  'payment.cash.hint': 'अपना आवेदन संदर्भ {ref} साथ रखें। काउंटर आपको रसीद देता है और भुगतान इस आवेदन में दर्ज करता है।',
  'payment.claim.receipt': 'रसीद संख्या',
  'payment.claim.receiptHint': 'काउंटर से मिली रसीद पर छपी होती है। रसीद की फ़ोटो लगाने पर वैकल्पिक।',
  'payment.claim.receiptPhoto': 'रसीद की फ़ोटो',
  'payment.claim.rule.cash': 'रसीद संख्या (कम से कम 3 अक्षर) लिखें या रसीद की फ़ोटो लगाएँ।',
  'payment.bank.title': 'बैंक ट्रांसफ़र (NEFT / IMPS)',
  'payment.bank.accountName': 'खाते का नाम',
  'payment.bank.accountNumber': 'खाता संख्या',
  'payment.bank.ifsc': 'IFSC कोड',
  'payment.bank.bankName': 'बैंक',
  'payment.copy': 'कॉपी करें',
  'payment.copied': 'कॉपी हो गया',
  'payment.instructions.title': 'कार्यालय के निर्देश',
  'payment.claim.intro': 'भुगतान कर चुके हैं? विवरण दें, ताकि कार्यालय अपने बैंक खाते में आपका भुगतान ढूँढ सके।',
  'payment.claim.method': 'आपने भुगतान कैसे किया?',
  'payment.claim.method.upi': 'UPI ऐप',
  'payment.claim.method.bank': 'बैंक ट्रांसफ़र (NEFT, IMPS)',
  'payment.claim.method.cash': 'कार्यालय के काउंटर पर नकद',
  'payment.claim.method.other': 'अन्य',
  'payment.claim.amount': 'चुकाई गई राशि (₹)',
  'payment.claim.paidOn': 'भुगतान की तारीख',
  'payment.claim.payer': 'भुगतान करने वाले खाताधारक का नाम (वैकल्पिक)',
  'payment.claim.payerHint': 'यदि भुगतान किसी और के खाते से हुआ हो, तो उनका नाम लिखें।',
  'payment.claim.rule': 'UTR लिखें (कम से कम 5 अक्षर) या भुगतान का स्क्रीनशॉट जोड़ें।',
  'payment.claim.screenshotAttached': 'स्क्रीनशॉट जुड़ा है',
  'payment.claim.reported': 'आपने क्या बताया',
  'payment.claim.reportedAt': 'बताने का समय',
  'payment.claim.edit': 'कुछ गलत हो गया? अपना प्रमाण बदलें',
  'payment.claim.cancelEdit': 'रद्द करें',
  'payment.claim.keepFile': 'यदि आप नया स्क्रीनशॉट नहीं चुनते, तो पहले वाला ही रहेगा।',
  'payment.rejected.title': 'कार्यालय आपका भुगतान नहीं ढूँढ सका',
  'payment.rejected.reason': 'कारण: {reason}',
  'payment.rejected.on': 'वापस भेजा गया: {at}',
  'payment.rejected.advice': 'कृपया विवरण जाँचकर फिर से भेजें। यदि ट्रांसफ़र हुआ ही नहीं था, तो ऊपर दिए किसी तरीके से अभी भुगतान करें।',
  'case.payment.claim.method': 'तरीका',
  'case.payment.claim.amount': 'बताई गई राशि',
  'case.payment.claim.paidOn': 'भुगतान की तारीख',
  'case.payment.claim.payer': 'भुगतान करने वाला खाताधारक',
  'case.payment.claim.at': 'बताने का समय',
  'case.payment.differs': '₹{due} से अलग',
  'case.payment.verify': 'कार्यालय का बैंक / UPI ऐप खोलकर {date} को ₹{due} की जमा राशि संदर्भ {ref} के साथ ढूँढें। स्क्रीनशॉट पर भरोसा न करें।',
  'case.payment.verify.reportedDate': 'बताई गई तारीख',
  'case.payment.verify.noRef': '(दिया नहीं गया)',
  'case.payment.payTo': 'पायलट को यहाँ भुगतान करने को कहा गया',
  'case.payment.bank': 'बैंक खाता',
  'case.payment.screenshot.loading': 'स्क्रीनशॉट लोड हो रहा है…',
  'case.payment.screenshot.enlarge': 'बड़ा करने के लिए क्लिक करें',
  'case.payment.screenshot.pdf': 'PDF खोलें',
  'case.payment.rejected.title': 'पहले वापस भेजे गए दावे',
  'case.payment.rejected.item': '{by} · {at}: {reason}',
  'case.payment.paidAmount': 'प्राप्त राशि',
  'action.confirmPayment.claimHeading': 'पायलट ने बताया',
  'action.confirmPayment.due': 'देय राशि: ₹{due}',
  'action.confirmPayment.amountLabel': 'प्राप्त राशि (₹)',
  'action.confirmPayment.verified': 'मुझे यह जमा राशि कार्यालय के बैंक स्टेटमेंट / UPI ऐप में मिल गई है',
  'action.confirmPayment.verifiedCash': 'मैंने यह नक़द काउंटर पर प्राप्त किया है और इसकी रसीद जारी की है',
  'action.confirmPayment.methodLabel': 'पैसा कैसे प्राप्त हुआ?',
  'action.confirmPayment.receiptLabel': 'काउंटर रसीद संख्या',
  'action.confirmPayment.receiptHint': 'काउंटर पर जारी नक़द रसीद की संख्या — यह पायलट के भुगतान रिकॉर्ड में दर्ज होती है।',
  'action.rejectPaymentClaim.label': 'भुगतान नहीं मिला — वापस भेजें',
  'action.rejectPaymentClaim.title': 'भुगतान का प्रमाण पायलट को वापस भेजें',
  'action.rejectPaymentClaim.reasonLabel': 'क्या नहीं मिला या मेल नहीं खाया?',
  'action.rejectPaymentClaim.reasonHint': '5–500 अक्षर। पायलट को यह कारण ई-मेल से भेजा जाएगा और वे अपना प्रमाण फिर से भेज सकते हैं।',
  'settings.manual.title': 'मैन्युअल भुगतान मार्ग (UPI / बैंक ट्रांसफ़र)',
  'settings.manual.description': 'जब मार्ग upi या office हो तब उपयोग होता है। पैसा कार्यालय के अपने खाते में जाता है; अधिकारी बैंक स्टेटमेंट से मिलान कर पुष्टि करते हैं।',
  'settings.config.bank_account_name': 'बैंक खाते का नाम',
  'settings.config.bank_account_number': 'बैंक खाता संख्या (9–18 अंक)',
  'settings.config.bank_ifsc': 'बैंक IFSC, जैसे SBIN0001234',
  'settings.config.bank_name': 'बैंक और शाखा',
  'settings.config.payment_provider.hint': 'चुनें कि पायलट परमिट शुल्क कैसे चुकाएँगे।',
  'settings.config.fee_mode.hint': 'flat = प्रति आवेदन एक शुल्क; per_week = प्रवास के हर 7 दिन पर।',
  'settings.config.payment_instructions.hint': 'upi और office मार्ग पर पायलट को दिखता है। नई पंक्तियाँ सुरक्षित रहती हैं।',
  'settings.option.none': 'none — कोई परमिट शुल्क नहीं',
  'settings.option.upi': 'upi — कार्यालय की UPI आईडी, अधिकारी पुष्टि करते हैं',
  'settings.option.razorpay': 'razorpay — होस्टेड पेमेंट लिंक',
  'settings.option.office': 'office — काउंटर / बैंक ट्रांसफ़र, अधिकारी पुष्टि करते हैं',
  'settings.option.flat': 'flat — प्रति आवेदन',
  'settings.option.per_week': 'per_week — प्रवास के प्रति 7 दिन',
  'status.card.showQr': 'QR पूर्ण स्क्रीन पर दिखाएं',
  'status.card.brightnessHint': 'स्कैन करने से पहले अपनी स्क्रीन की चमक पूरी बढ़ा लें।',
  'status.card.download': 'कार्ड डाउनलोड करें (PDF)',
  'status.card.addHome': 'लॉन्च साइट पर ऑफ़लाइन उपयोग के लिए इस पेज को होम स्क्रीन पर जोड़ें।',
  'status.card.revoked': 'यह कार्ड निरस्त कर दिया गया है और अब मान्य नहीं है।',
  'status.myApplications': 'आपके सहेजे गए आवेदन',

  // ── Timeline state explanations ───────────────────────────────────────────
  'status.explain.Submitted': 'हमें आपका आवेदन मिल गया है और हम प्रारंभिक जांच कर रहे हैं।',
  'status.explain.Validated': 'आपकी जांच पूर्ण हो चुकी है और आपका आवेदन मूल्यांकन की कतार में है।',
  'status.explain.CorrectionRequested': 'कृपया नीचे मांगे गए सुधार प्रदान करें।',
  'status.explain.ReadyForEvaluation': 'आपका आवेदन हमारी टीम द्वारा मूल्यांकन की कतार में है।',
  'status.explain.Evaluated': 'आपके प्रमाणन और उपकरण का मूल्यांकन हो चुका है; सिफ़ारिश की प्रतीक्षा है।',
  'status.explain.EvaluationFailed': 'मूल्यांकन में उत्तीर्ण नहीं हुआ — एसडीएम कार्यालय आपके आवेदन की समीक्षा कर रहा है।',
  'status.explain.UnderReview': 'एसडीएम कार्यालय आपके आवेदन की समीक्षा कर रहा है।',
  'status.explain.PaymentPending': 'आपका आवेदन स्वीकृत हो गया है। नीचे परमिट शुल्क का भुगतान करें, फिर आपका कार्ड जारी किया जाएगा।',
  'status.explain.Approved': 'आपका आवेदन स्वीकृत हो गया है — आपका कार्ड जारी किया जा रहा है।',
  'status.explain.CardIssued': 'आपका फ्री फ़्लायर कार्ड जारी कर दिया गया है। यह नीचे दिखाया गया है।',
  'status.explain.Rejected': 'आपका आवेदन स्वीकृत नहीं हुआ।',
  'status.explain.Revoked': 'आपका कार्ड निरस्त कर दिया गया है।',
  'status.explain.Expired': 'इस सीज़न के लिए आपका कार्ड समाप्त हो चुका है।',

  // ── Office console (WP7) — chrome, guards, shortcuts ──────────────────────
  'office.nav.overview': 'अवलोकन',
  'office.nav.queue': 'कतार',
  'office.nav.cases': 'मामले',
  'office.nav.dashboard': 'डैशबोर्ड',
  'office.nav.issue': 'कार्ड जारी करें',
  'office.nav.staff': 'स्टाफ़',
  'office.nav.settings': 'सेटिंग्स',
  'office.nav.exports': 'निर्यात',
  'office.nav.responder': 'रेस्पॉन्डर',
  'office.header.signOut': 'साइन आउट',
  'office.guard.signInTitle': 'साइन इन आवश्यक',
  'office.guard.signInBody': 'ऑफ़िस कंसोल केवल एसडीएम कार्यालय स्टाफ़ के लिए है। जारी रखने हेतु अपने स्टाफ़ पासफ़्रेज़ से साइन इन करें।',
  'office.guard.goToSignIn': 'स्टाफ़ साइन इन पर जाएं',
  'office.guard.notAllowedTitle': 'आपकी भूमिका के लिए उपलब्ध नहीं',
  'office.guard.notAllowedBody': 'आपकी भूमिका ({role}) को इस अनुभाग तक पहुंच नहीं है।',
  'office.guard.sessionExpired': 'आपका सत्र समाप्त हो गया — कृपया दोबारा साइन इन करें।',
  'office.help.title': 'कीबोर्ड शॉर्टकट',
  'office.help.search': 'खोज पर फ़ोकस करें',
  'office.help.moveRows': 'पंक्तियों के बीच जाएं',
  'office.help.openRow': 'चुनी गई पंक्ति खोलें',
  'office.help.closeModal': 'संवाद/मोडल बंद करें',
  'office.help.open': 'यह सहायता दिखाएं',

  // ── Office overview (/office) — the SDM/DC executive snapshot ────────────
  'office.overview.greeting.morning': 'सुप्रभात, {name}',
  'office.overview.greeting.afternoon': 'नमस्कार, {name}',
  'office.overview.greeting.evening': 'शुभ संध्या, {name}',
  'office.overview.season.daysLeft': '{days} दिन शेष',
  'office.overview.season.lastDay': 'अंतिम दिन',
  'office.overview.season.ended': 'सीज़न समाप्त',
  'office.overview.status.registerLive': 'रजिस्टर सक्रिय है',
  'office.overview.status.backend': 'बैकएंड: {backend} · ऑनलाइन',
  'office.overview.status.backend.offline': 'बैकएंड: ऑफ़लाइन',
  'office.overview.backend.appsscript': 'Apps Script',
  'office.overview.backend.devserver': 'डेव सर्वर',
  'office.overview.backend.demo': 'डेमो',
  'office.overview.kpi.pending': 'समीक्षा हेतु लंबित',
  'office.overview.kpi.correction': 'सुधार की प्रतीक्षा में',
  'office.overview.kpi.correction.oldest': 'सबसे पुराना {age}',
  'office.overview.kpi.ready': 'जारी करने हेतु तैयार',
  'office.overview.kpi.issuedToday': 'आज जारी किए गए',
  'office.overview.kpi.expiring': '7 दिनों में समाप्त',
  'office.overview.kpi.avgApproval': 'औसत स्वीकृति समय',
  'office.overview.kpi.avgApproval.value': '{hours} घं.',
  'office.overview.kpi.avgApproval.none': 'अभी डेटा नहीं है',
  'office.overview.pipeline.title': 'पाइपलाइन',
  'office.overview.pipeline.stage.submitted': 'प्रस्तुत',
  'office.overview.pipeline.stage.checked': 'जांचा गया',
  'office.overview.pipeline.stage.evaluation': 'मूल्यांकन',
  'office.overview.pipeline.stage.review': 'समीक्षा',
  'office.overview.pipeline.stage.payment': 'भुगतान प्रतीक्षित',
  'office.overview.pipeline.stage.approved': 'स्वीकृत',
  'office.overview.pipeline.stage.issued': 'जारी',
  'office.overview.decision.title': 'आपके निर्णय की प्रतीक्षा में',
  'office.overview.decision.andMore': 'और {count} अधिक',
  'office.overview.decision.review': 'समीक्षा करें',
  'office.overview.decision.view': 'देखें',
  'office.overview.decision.empty.title': 'आपके लिए कुछ भी लंबित नहीं है',
  'office.overview.decision.empty.body': 'अभी आपकी कतार में कुछ नहीं है — बाद में देखें, या पूरी कतार ब्राउज़ करें।',
  'office.overview.decision.assignedTo': '{name} को सौंपा गया',
  'office.overview.decision.unassigned': 'असाइन नहीं किया गया',
  'office.overview.season.title': 'सीज़न एक नज़र में',
  'office.overview.season.registrationsByDay': 'पंजीकरण, पिछले 30 दिन',
  'office.overview.season.nationalitySplit': 'भारतीय बनाम विदेशी',
  'office.overview.season.topNationalities': 'शीर्ष राष्ट्रीयताएं',
  'office.overview.season.tierMix': 'जोखिम स्तर मिश्रण',
  'office.overview.season.noData': 'इस सीज़न में अभी तक कोई पंजीकरण नहीं है।',
  'office.overview.activity.title': 'गतिविधि',
  'office.overview.activity.empty': 'इस सीज़न में अभी तक कोई गतिविधि नहीं है।',
  'office.overview.activity.line': '{name} → {state}',
  'office.overview.quickActions.title': 'त्वरित कार्रवाइयां',
  'office.overview.quickActions.registerOnBehalf': 'किसी पायलट की ओर से पंजीकरण करें',
  'office.overview.quickActions.issueCards': 'कार्ड जारी करें',
  'office.overview.quickActions.verify': 'कार्ड सत्यापित करें',
  'office.overview.quickActions.printSheet': 'प्रिंट शीट',
  'office.overview.quickActions.publicStats': 'सार्वजनिक आंकड़े',
  'office.overview.offline.body': '{time} की अंतिम सहेजी गई संख्याएं दिखा रहे हैं।',
  'office.overview.error.title': 'अवलोकन लोड नहीं हो सका',
  'office.overview.error.retry': 'पुनः प्रयास करें',

  // ── Queue ──────────────────────────────────────────────────────────────
  'queue.title': 'कतार',
  'queue.description': 'कार्यालय की कार्रवाई की प्रतीक्षा में आवेदन, स्थिति के अनुसार समूहित।',
  'queue.view.mine': 'मेरी कतार',
  'queue.view.all': 'सभी',
  'queue.view.attention': 'ध्यान देने योग्य',
  'queue.view.ready': 'जारी करने हेतु तैयार',
  'queue.view.issued': 'जारी किया गया',
  'queue.view.payment': 'भुगतान प्रतीक्षित',
  'queue.payment.claimed': 'प्रमाण जमा हुआ — जाँचें',
  'queue.payment.sentBack': 'वापस भेजा गया',
  'queue.filters.state': 'स्थिति',
  'queue.filters.tier': 'जोखिम स्तर',
  'queue.filters.nationality': 'राष्ट्रीयता',
  'queue.filters.indian': 'भारतीय',
  'queue.filters.foreign': 'विदेशी',
  'queue.filters.assignedToMe': 'मुझे सौंपा गया',
  'queue.filters.search': 'खोजें',
  'queue.filters.searchPlaceholder': 'नाम, संदर्भ, दस्तावेज़, कार्ड खोजें…',
  'queue.table.age': 'आयु',
  'queue.table.name': 'नाम',
  'queue.table.nationality': 'राष्ट्रीयता',
  'queue.table.cert': 'प्रमाणन',
  'queue.table.glider': 'ग्लाइडर वर्ग',
  'queue.table.certGlider': 'प्रमाणन / वर्ग',
  'queue.table.tier': 'निष्कर्ष',
  'queue.table.assigned': 'सौंपा गया',
  'queue.table.state': 'स्थिति',
  'queue.bulk.selected': '{count} चयनित',
  'queue.bulk.recommendAll': 'सभी की सिफ़ारिश करें',
  'queue.bulk.approveAll': 'सभी स्वीकृत करें',
  'queue.bulk.running': '{total} में से {done} पर कार्य जारी…',
  'queue.bulk.done': 'पूर्ण: {ok} सफल, {failed} विफल।',
  'queue.refresh': 'ताज़ा करें',
  'queue.lastUpdated': 'अंतिम अद्यतन {time}',
  'queue.empty.title': 'यहां कुछ नहीं',
  'queue.empty.body': 'इस दृश्य और फ़िल्टर संयोजन से कोई आवेदन मेल नहीं खाता।',
  'queue.unassigned': 'असाइन नहीं किया गया',

  // ── Case view ──────────────────────────────────────────────────────────
  'case.tabs.entries': 'प्रविष्टियां',
  'case.tabs.checks': 'जांच',
  'case.tabs.documents': 'दस्तावेज़',
  'case.back': 'कतार पर वापस जाएं',
  'case.notFound.title': 'मामला नहीं मिला',
  'case.notFound.body': 'यह आवेदन संदर्भ मौजूद नहीं है या आपके पास इसकी पहुंच नहीं है।',
  'case.copy': 'कॉपी करें',
  'case.copied': 'कॉपी हो गया',
  'case.whatsapp': 'व्हाट्सऐप',
  'case.email': 'ईमेल',
  'case.riskTier': 'जोखिम स्तर',
  'case.rulesetVersion': 'नियमसेट संस्करण',
  'case.section.identity': 'पायलट का विवरण',
  'case.section.documents': 'पहचान दस्तावेज़',
  'case.section.equipment': 'उपकरण और प्रमाणन',
  'case.section.safety': 'सुरक्षा, बीमा और आपातकालीन संपर्क',
  'case.section.stay': 'बीर में ठहराव और बचाव रेडियो',
  'case.override': 'ओवरराइड',
  'case.override.title': 'निष्कर्ष ओवरराइड करें',
  'case.override.reasonLabel': 'इस निष्कर्ष को ओवरराइड करने का कारण',
  'case.override.reasonHint': 'आपके नाम के विरुद्ध ऑडिट ट्रेल में दर्ज किया जाएगा।',
  'case.documents.doc': 'पहचान दस्तावेज़',
  'case.documents.photo': 'कार्ड फ़ोटो',
  'case.documents.cert': 'प्रमाणन कार्ड',
  'case.documents.ins': 'बीमा',
  'case.documents.none': 'अपलोड नहीं किया गया',
  'case.documents.open': 'खोलें',
  'case.documents.openTab': 'नए टैब में खोलें',
  'case.documents.download': 'डाउनलोड',
  'case.documents.driveFolder': 'इस आवेदक का फ़ोल्डर Drive में खोलें',
  'case.documents.driveFolderHint': 'कार्यालय के Google खाते की आवश्यकता',
  'case.documents.zoomIn': 'ज़ूम इन करें',
  'case.documents.zoomOut': 'ज़ूम आउट करें',
  'case.documents.rotate': 'घुमाएं',
  'case.documents.typedVsDocument': 'टाइप किया गया बनाम दस्तावेज़',
  'case.documents.typed': 'पायलट द्वारा टाइप किया गया',
  'case.documents.mrz': 'दस्तावेज़ से (MRZ)',
  'case.timeline.title': 'समयरेखा और ऑडिट',
  'case.timeline.empty': 'अभी तक कोई ऑडिट इतिहास नहीं।',
  'case.notes.title': 'टिप्पणियां',
  'case.notes.placeholder': 'एक आंतरिक टिप्पणी जोड़ें…',
  'case.notes.add': 'टिप्पणी जोड़ें',
  'case.notes.empty': 'अभी तक कोई टिप्पणी नहीं।',
  'case.conflict.title': 'यह मामला बदल गया है',
  'case.conflict.body': 'जब आप इसे देख रहे थे, किसी और ने इस मामले को अद्यतन कर दिया।',
  'case.conflict.reload': 'पुनः लोड करें',
  'case.print': 'मामले का सारांश प्रिंट करें',
  'case.reload': 'पुनः लोड करें',
  'case.actionBar.empty': 'अभी इस मामले पर आपकी भूमिका के लिए कोई कार्रवाई उपलब्ध नहीं है।',

  // ── Case actions (action bar + modals) ────────────────────────────────
  'action.assign.label': 'सौंपें',
  'action.assign.title': 'यह मामला सौंपें',
  'action.assign.staffLabel': 'इन्हें सौंपें',
  'action.assign.staffTextLabel': 'स्टाफ़ उपयोगकर्ता नाम',
  'action.note.label': 'टिप्पणी जोड़ें',
  'action.note.title': 'एक आंतरिक टिप्पणी जोड़ें',
  'action.note.textLabel': 'टिप्पणी',
  'action.requestCorrection.label': 'सुधार का अनुरोध करें',
  'action.requestCorrection.title': 'सुधार का अनुरोध करें',
  'action.requestCorrection.itemsLabel': 'क्या ठीक करना है',
  'action.requestCorrection.messageLabel': 'पायलट को संदेश',
  'action.requestCorrection.messageHint': 'वैकल्पिक — उनके स्टेटस पेज पर चेकलिस्ट के साथ दिखाया जाएगा।',
  'action.evaluate.label': 'मूल्यांकन करें',
  'action.evaluate.title': 'मूल्यांकन चेकलिस्ट',
  'action.evaluate.outcomeLabel': 'परिणाम',
  'action.evaluate.outcome.pass': 'उत्तीर्ण',
  'action.evaluate.outcome.conditional': 'सशर्त',
  'action.evaluate.outcome.fail': 'अनुत्तीर्ण',
  'action.evaluate.notesLabel': 'टिप्पणियां',
  'action.evaluate.checklist.identity': 'पायलट की पहचान दस्तावेज़ से मेल खाती है',
  'action.evaluate.checklist.certSighted': 'प्रमाणन कार्ड देखा गया',
  'action.evaluate.checklist.gliderMatch': 'ग्लाइडर घोषित मॉडल और वर्ग से मेल खाता है',
  'action.evaluate.checklist.reserve': 'रिज़र्व लगा हुआ और वैध तिथि में है',
  'action.evaluate.checklist.gear': 'हार्नेस और हेलमेट स्वीकार्य',
  'action.evaluate.checklist.briefed': 'पायलट को साइट नियमों और नो-फ़्लाई ज़ोन के बारे में जानकारी दी गई',
  'action.evaluate.checklist.fitToday': 'आज के लिए मौसम/कौशल उपयुक्त',
  'action.evaluate.checklist.insurance': 'बीमा देखा गया',
  'action.recommend.label': 'सिफ़ारिश करें',
  'action.recommend.title': 'सिफ़ारिश भेजें',
  'action.recommend.recommendationLabel': 'सिफ़ारिश',
  'action.recommend.recommendation.approve': 'स्वीकृति की सिफ़ारिश करें',
  'action.recommend.recommendation.reject': 'अस्वीकृति की सिफ़ारिश करें',
  'action.recommend.noteLabel': 'टिप्पणी',
  'action.approve.label': 'स्वीकृत करें',
  'action.approve.title': 'यह आवेदन स्वीकृत करें',
  'action.approve.reasonLabel': 'कारण (वैकल्पिक)',
  'action.approve.warnNotice': 'इस आवेदन में अभी भी अनसुलझी चेतावनियां हैं — आप फिर भी स्वीकृत कर सकते हैं।',
  'action.reject.label': 'अस्वीकृत करें',
  'action.reject.title': 'यह आवेदन अस्वीकृत करें',
  'action.reject.reasonLabel': 'कारण',
  'action.reject.reasonHint': 'कम से कम 10 अक्षर — पायलट को दिखाया जाएगा।',
  'action.revoke.label': 'कार्ड निरस्त करें',
  'action.revoke.title': 'यह कार्ड निरस्त करें',
  'action.revoke.reasonLabel': 'कारण',
  'action.reissue.label': 'पुनः जारी करें',
  'action.reissue.title': 'कार्ड पुनः जारी करें',
  'action.reissue.confirm': '/issue से इस पायलट के लिए एक नया कार्ड आवंटित किया जाएगा। जारी रखें?',
  'action.markPrinted.label': 'प्रिंट किया चिह्नित करें',
  'action.markPrinted.title': 'कार्ड को प्रिंट किया चिह्नित करें',
  'action.markPrinted.sheetLabel': 'प्रिंट शीट / बैच आईडी',
  'action.reopen.label': 'फिर से खोलें',
  'action.reopen.title': 'यह आवेदन फिर से खोलें',
  'action.reopen.confirm': 'इससे आवेदन कतार की शुरुआत में वापस चला जाएगा। जारी रखें?',
  'action.confirmPayment.label': 'भुगतान की पुष्टि करें',
  'action.confirmPayment.title': 'पुष्टि करें कि परमिट शुल्क प्राप्त हुआ',
  'action.confirmPayment.referenceLabel': 'UTR / लेन-देन आईडी',
  'action.confirmPayment.referenceHint': 'जैसा बैंक स्टेटमेंट या UPI ऐप में दिखता है। पायलट की रिपोर्ट से पहले से भरा हुआ — जाँचें कि यह वास्तव में प्राप्त राशि से मेल खाता है।',
  'action.confirmPayment.noteLabel': 'टिप्पणी (वैकल्पिक)',
  'action.waivePayment.label': 'शुल्क माफ़ करें',
  'action.waivePayment.title': 'परमिट शुल्क माफ़ करें',
  'action.waivePayment.reasonLabel': 'माफ़ी का कारण (आवश्यक, ऑडिट लॉग में दर्ज)',
  'action.resendPaymentLink.label': 'भुगतान विवरण फिर भेजें',
  'action.resendPaymentLink.title': 'भुगतान ई-मेल फिर से भेजें',
  'action.resendPaymentLink.confirm': 'पायलट को भुगतान लिंक या UPI विवरण और नया स्टेटस लिंक वाला नया ई-मेल मिलेगा। समाप्त हो चुका गेटवे लिंक फिर से बनाया जाएगा।',
  'action.override.label': 'ओवरराइड',
  'action.reasonLabel': 'कारण',
  'action.submit': 'जमा करें',
  'action.success': '{ref} के लिए {action} पूर्ण।',

  // ── WhatsApp / email templates ─────────────────────────────────────────
  'template.correction.text': 'नमस्ते {name}, यह एसडीएम बैजनाथ पैराग्लाइडिंग कार्यालय है, आपके फ्री फ़्लायर कार्ड आवेदन {ref} के संबंध में। हमें आपसे एक सुधार चाहिए — कृपया विवरण के लिए अपना स्टेटस पेज देखें।',
  'template.approval.text': 'नमस्ते {name}, अच्छी खबर — आपका फ्री फ़्लायर कार्ड आवेदन {ref} स्वीकृत हो गया है। आपका कार्ड जल्द ही जारी किया जाएगा।',
  'template.cardReady.text': 'नमस्ते {name}, आवेदन {ref} के लिए आपका फ्री फ़्लायर कार्ड तैयार है। कृपया इसे लेने के लिए बीर बिलिंग स्थित एसडीएम कार्यालय आएं।',

  // ── Evaluator screen ───────────────────────────────────────────────────
  'evaluator.title': 'आज के मूल्यांकन',
  'evaluator.description': 'लॉन्च साइट पर ग्लाइडर/प्रमाणन जांच हेतु तैयार आवेदक।',
  'evaluator.search': 'नाम, संदर्भ या कार्ड नंबर खोजें',
  'evaluator.scanCard': 'कार्ड स्कैन करें',
  'evaluator.empty.title': 'अभी मूल्यांकन हेतु कुछ नहीं',
  'evaluator.empty.body': 'प्रारंभिक जांच पूर्ण होते ही नए आवेदक यहां दिखाई देंगे।',
  'evaluator.classWarning': 'ग्लाइडर वर्ग इस प्रमाणन स्तर से अधिक है',
  'evaluator.open': 'खोलें',
  'evaluator.back': 'सूची पर वापस जाएं',
  'evaluator.checklist.title': 'मूल्यांकन चेकलिस्ट',
  'evaluator.signature.title': 'मूल्यांकनकर्ता हस्ताक्षर',
  'evaluator.signature.clear': 'साफ़ करें',
  'evaluator.signature.hint': 'अपनी उंगली या स्टाइलस से हस्ताक्षर करें। यह केवल इस डिवाइस पर रखा जाता है; एक छोटा हैश आपकी टिप्पणियों के साथ sig:<hash> के रूप में दर्ज किया जाता है।',
  'evaluator.signature.required': 'जमा करने से पहले कृपया हस्ताक्षर करें।',
  'evaluator.submit': 'मूल्यांकन जमा करें',
  'evaluator.submitted': '{ref} के लिए मूल्यांकन दर्ज किया गया।',
  'evaluator.offline.queued': 'ऑफ़लाइन सहेजा गया — फिर से कनेक्ट होते ही स्वतः भेज दिया जाएगा।',
  'evaluator.outbox.pending': 'आउटबॉक्स में {count} लंबित',
  'evaluator.outbox.flushed': '{count} कतारबद्ध मूल्यांकन भेजे गए।',

  // ── Responder (emergency-only) view ────────────────────────────────────
  'responder.title': 'आपातकालीन खोज',
  'responder.description': 'केवल आपातकालीन संपर्क विवरण देखने हेतु पायलट खोजें।',
  'responder.search': 'नाम, कार्ड नंबर या संदर्भ खोजें',
  'responder.notFound.title': 'कोई मेल नहीं',
  'responder.notFound.body': 'उस खोज के लिए कोई पायलट नहीं मिला।',
  'responder.field.name': 'नाम',
  'responder.field.nationality': 'राष्ट्रीयता',
  'responder.field.phone': 'पायलट फ़ोन',
  'responder.field.emgContact': 'आपातकालीन संपर्क',
  'responder.field.emgRelationship': 'संबंध',
  'responder.field.emgPhone': 'आपातकालीन संपर्क फ़ोन',
  'responder.field.bloodGroup': 'रक्त समूह',
  'responder.field.stayPlace': 'ठहरे हैं',
  'responder.field.stayArea': 'क्षेत्र',
  'responder.field.radioFrequency': 'रेडियो फ़्रीक्वेंसी',
  'responder.field.medicalValidTo': 'चिकित्सा बीमा वैधता तिथि',
  'responder.field.cardNo': 'कार्ड नंबर',
  'responder.call': 'कॉल करें',

  // ── Staff admin ────────────────────────────────────────────────────────
  'staff.title': 'स्टाफ़',
  'staff.description': 'कार्यालय खाते, भूमिकाएं और पासफ़्रेज़ प्रबंधित करें।',
  'staff.table.user': 'उपयोगकर्ता',
  'staff.table.displayName': 'प्रदर्शन नाम',
  'staff.table.role': 'भूमिका',
  'staff.table.active': 'सक्रिय',
  'staff.add': 'स्टाफ़ जोड़ें',
  'staff.edit': 'स्टाफ़ संपादित करें',
  'staff.drawer.user': 'उपयोगकर्ता नाम',
  'staff.drawer.displayName': 'प्रदर्शन नाम',
  'staff.drawer.role': 'भूमिका',
  'staff.drawer.active': 'सक्रिय',
  'staff.drawer.setPassphrase': 'पासफ़्रेज़ सेट करें',
  'staff.drawer.passphrase1': 'नया पासफ़्रेज़',
  'staff.drawer.passphrase2': 'पासफ़्रेज़ की पुष्टि करें',
  'staff.drawer.passphraseMismatch': 'पासफ़्रेज़ मेल नहीं खाते।',
  'staff.drawer.strength': 'मज़बूती',
  'staff.drawer.strength.0': 'बहुत कमज़ोर',
  'staff.drawer.strength.1': 'कमज़ोर',
  'staff.drawer.strength.2': 'ठीक',
  'staff.drawer.strength.3': 'मज़बूत',
  'staff.drawer.strength.4': 'बहुत मज़बूत',
  'staff.drawer.save': 'सहेजें',
  'staff.saved': 'स्टाफ़ रिकॉर्ड सहेजा गया।',

  // ── Settings (admin) ───────────────────────────────────────────────────
  'settings.title': 'सेटिंग्स',
  'settings.description': 'टेनेंट कॉन्फ़िगरेशन — परिवर्तन तुरंत प्रभावी होते हैं।',
  'settings.warning': 'ये सेटिंग्स पूरे कार्यालय को प्रभावित करती हैं। सहेजने से पहले दोबारा जांच लें।',
  'settings.config.season': 'सीज़न',
  'settings.config.card_seq': 'कार्ड क्रम (केवल पढ़ने योग्य)',
  'settings.config.key_id': 'सक्रिय हस्ताक्षर कुंजी',
  'settings.config.ruleset_version': 'नियमसेट संस्करण',
  'settings.config.thresholds': 'सीमाएं',
  'settings.config.payment_provider': 'परमिट शुल्क मार्ग: none, upi, razorpay या office',
  'settings.config.fee_inr_indian': 'परमिट शुल्क — भारतीय पायलट (₹)',
  'settings.config.fee_inr_foreign': 'परमिट शुल्क — विदेशी पायलट (₹)',
  'settings.config.payment_due_days': 'भुगतान के लिए दिन',
  'settings.config.upi_vpa': 'कार्यालय की UPI आईडी (upi मार्ग), जैसे sdmbaijnath@sbi',
  'settings.config.fee_mode': 'शुल्क नियम: flat (प्रति आवेदन) या per_week (ठहराव के प्रति 7 दिन)',
  'settings.config.fee_inr_per_week': 'ठहराव के प्रति 7 दिन परमिट शुल्क (₹) — per_week नियम',
  'settings.config.payment_instructions': 'भुगतान कैसे करें — office मार्ग पर पायलट को दिखाया जाने वाला निर्देश (काउंटर समय, बैंक विवरण …)',
  'settings.config.upi_payee_name': 'पायलट के ऐप में दिखने वाला प्राप्तकर्ता नाम',
  'settings.config.upi_qr_payload': 'कार्यालय के छपे UPI QR का टेक्स्ट (वैकल्पिक)',
  'settings.config.upi_qr_payload.hint': 'बैंक के छपे QR को किसी भी QR-रीडर ऐप से स्कैन करें और जो टेक्स्ट दिखे उसे यहाँ चिपकाएँ (upi://pay?pa= से शुरू होता है)। फिर पायलटों को वही QR राशि और संदर्भ भरा हुआ मिलता है। खाली छोड़ने पर UPI id से सादा QR बनता है।',
  'settings.qrPreview': 'पूर्वावलोकन — अपने फ़ोन से स्कैन करें: इसे छपे QR वाला ही प्राप्तकर्ता खोलना चाहिए।',
  'settings.payments.title': 'पेमेंट गेटवे (Razorpay)',
  'settings.payments.description': 'Razorpay डैशबोर्ड से Key Id और Key Secret यहाँ डालें (टेस्ट कुंजियाँ rzp_test_ से शुरू होती हैं)। वेबहुक टोकन कोई भी लंबा यादृच्छिक टेक्स्ट हो सकता है — वही मान Razorpay → Webhooks में नीचे दिए URL के साथ डालें और payment_link.paid इवेंट चुनें। मान कार्यालय खाते की Script Properties में सुरक्षित रहते हैं और दोबारा नहीं दिखाए जाते।',
  'settings.payments.keyId': 'Key Id',
  'settings.payments.keySecret': 'Key Secret',
  'settings.payments.webhookToken': 'वेबहुक टोकन',
  'settings.payments.webhookUrl': 'Razorpay में डालने के लिए वेबहुक URL',
  'settings.payments.save': 'गेटवे कुंजियाँ सहेजें',
  'settings.payments.saved': 'गेटवे कुंजियाँ सहेज ली गईं।',
  'settings.payments.present': 'सेट है',
  'settings.payments.absent': 'सेट नहीं',
  'settings.payments.leaveBlank': 'किसी फ़ील्ड को खाली छोड़ने पर उसका वर्तमान मान बना रहता है।',
  'settings.save': 'सहेजें',
  'settings.saved': '{key} अद्यतन किया गया।',
  'settings.tenant.title': 'टेनेंट',
  'settings.demo.title': 'डेमो डेटा',
  'settings.demo.resetButton': 'डेमो डेटा रीसेट करें',
  'settings.demo.resetConfirm': 'यह सभी डेमो आवेदनों को मिटा देगा और नया नमूना डेटा फिर से जोड़ देगा। जारी रखें?',
  'settings.demo.resetDone': 'डेमो डेटा रीसेट हो गया।',
  'settings.drive.title': 'Google Drive पर दस्तावेज़',
  'settings.drive.description': 'दस्तावेज़ seasons / <सीज़न> / <माह> / <दिन> / <उपनाम, नाम (संदर्भ)> में तय नामों (photo.jpg, id-document.jpg, certificate.pdf, insurance.pdf, payment-proof.jpg) से रखे जाते हैं। 17 अक्टूबर 2026 से पहले के आवेदन संदर्भ-वार सपाट फ़ोल्डरों में थे; यह उन्हें सही जगह ले जाता है। दोबारा चलाना सुरक्षित है।',
  'settings.drive.button': 'Drive फ़ोल्डर अभी व्यवस्थित करें',
  'settings.drive.running': 'व्यवस्थित हो रहा है… {total} में से {done} आवेदन',
  'settings.drive.done': 'पूर्ण: {total} आवेदन · {moved} फ़ाइलें स्थानांतरित · {renamed} नाम बदले · {unchanged} पहले से सही जगह · {missing} नहीं मिलीं · {folders} खाली फ़ोल्डर हटाए',
  'settings.drive.root': 'फ़ाइलें यहाँ हैं: {path}',
  'settings.checks.title': 'प्रारंभिक जाँचें',
  'settings.checks.description': 'अभी तक स्वीकृत न हुए हर आवेदन पर वर्तमान नियमों (नियम-सेट {version}) से प्रारंभिक जाँचें दोबारा चलाता है। जो आवेदन केवल ऐसी जाँच के कारण रुका था जो अब विफल नहीं होती, वह मूल्यांकन कतार में आगे बढ़ जाता है। अधिकारी के ओवरराइड बने रहते हैं। स्वीकृत और जारी किए गए आवेदन जैसे थे वैसे ही रहते हैं।',
  'settings.checks.button': 'जाँचें अभी दोबारा चलाएँ',
  'settings.checks.running': 'दोबारा चल रहा है… {total} में से {done} आवेदन',
  'settings.checks.done': 'पूर्ण: {checked} दोबारा जाँचे गए · {changed} बदले · {released} मूल्यांकन कतार में भेजे गए · {skipped} पहले से स्वीकृत/जारी (जैसे थे वैसे ही)',

  // ── Exports (admin/sdm) ────────────────────────────────────────────────
  'exports.title': 'निर्यात',
  'exports.description': 'रजिस्टर, ऑडिट लॉग और कार्ड सूची डाउनलोड करें।',
  'exports.applicationsCsv': 'आवेदन (CSV)',
  'exports.auditCsv': 'ऑडिट लॉग (CSV)',
  'exports.cardsCsv': 'कार्ड (CSV)',
  'exports.json': 'पूर्ण निर्यात (JSON)',
  'exports.revocations.title': 'निरस्तीकरण सूची',
  'exports.revocations.current': 'वर्तमान में प्रकाशित: संस्करण {version}, {age}',
  'exports.revocations.none': 'अभी तक कोई निरस्तीकरण सूची प्रकाशित नहीं हुई है।',
  'exports.revocations.draft': 'ड्राफ़्ट: संस्करण {version}, {count} कार्ड',
  'exports.revocations.signLink': '/issue में हस्ताक्षर करें और प्रकाशित करें',

  // ── संक्षिप्त कार्यप्रवाह-स्थिति लेबल (चार्ट अक्ष/श्रेणी लेबल — लंबे, पायलट-केंद्रित वाक्यों के लिए status.* देखें) ──
  'queueState.Submitted': 'दाखिल',
  'queueState.Validated': 'सत्यापित',
  'queueState.CorrectionRequested': 'सुधार अनुरोधित',
  'queueState.ReadyForEvaluation': 'मूल्यांकन हेतु तैयार',
  'queueState.Evaluated': 'मूल्यांकित',
  'queueState.EvaluationFailed': 'मूल्यांकन विफल',
  'queueState.UnderReview': 'समीक्षाधीन',
  'queueState.PaymentPending': 'भुगतान प्रतीक्षित',
  'queueState.Approved': 'स्वीकृत',
  'queueState.CardIssued': 'कार्ड जारी',
  'queueState.Rejected': 'अस्वीकृत',
  'queueState.Revoked': 'निरस्त',
  'queueState.Expired': 'समाप्त',

  // ── चार्ट (src/charts/* — हर चार्ट का साझा ढांचा) ───────────────────────
  'charts.chartView': 'चार्ट',
  'charts.tableView': 'तालिका',
  'charts.downloadCsv': 'CSV डाउनलोड करें',
  'charts.asOf': '{time} तक की स्थिति',
  'charts.noData': 'अभी कोई डेटा नहीं',
  'charts.other': 'अन्य',
  'charts.count': 'गिनती',
  'charts.category': 'श्रेणी',

  // ── डैशबोर्ड (SDM/DC/एडमिन/सहायक, WP9) ───────────────────────────────
  'dashboard.eyebrow': 'डैशबोर्ड',
  'dashboard.title': 'परिचालन डैशबोर्ड',
  'dashboard.tabs.aria': 'डैशबोर्ड दृश्य',
  'dashboard.tabs.operations': 'परिचालन',
  'dashboard.tabs.season': 'सीज़न',
  'dashboard.guard.signInBody': 'डैशबोर्ड केवल SDM, DC और एडमिन भूमिकाओं के लिए हैं। जारी रखने के लिए अपने स्टाफ पासफ़्रेज़ से साइन इन करें।',
  'dashboard.guard.notAllowedBody': 'आपकी भूमिका ({role}) को डैशबोर्ड तक पहुंच नहीं है।',
  'dashboard.error.title': 'डैशबोर्ड लोड नहीं हो सका',
  'dashboard.error.body': 'पिछला अनुरोध विफल रहा। अपना कनेक्शन जांचें और फिर से प्रयास करें।',
  'dashboard.error.retry': 'फिर से प्रयास करें',
  'dashboard.offline.title': 'अंतिम सहेजे गए आंकड़े दिखाए जा रहे हैं',
  'dashboard.offline.body': 'आप ऑफ़लाइन हैं — यह इस डिवाइस पर सहेजा गया अंतिम स्नैपशॉट है, {time} का।',
  'dashboard.asOf': '{time} तक की स्थिति',
  'dashboard.refresh': 'ताज़ा करें',

  'dashboard.ops.tile.pending': 'समीक्षा के लिए लंबित',
  'dashboard.ops.tile.correction': 'सुधार की प्रतीक्षा में',
  'dashboard.ops.tile.correction.oldest': 'सबसे पुराना {age}',
  'dashboard.ops.tile.ready': 'जारी करने हेतु तैयार',
  'dashboard.ops.tile.issuedToday': 'आज जारी किए गए',
  'dashboard.ops.tile.expiring': '7 दिनों में समाप्त हो रहे',
  'dashboard.ops.tile.avgApproval': 'औसत स्वीकृति समय',
  'dashboard.ops.tile.avgApproval.value': '{hours} घंटे',
  'dashboard.ops.tile.avgApproval.none': 'अभी कोई निर्णय नहीं',
  'dashboard.ops.queueByStage.title': 'चरण अनुसार कतार',
  'dashboard.ops.queueByStage.subtitle': 'हर चरण में मौजूद आवेदन, सबसे पुरानी प्रतीक्षा अवधि के साथ',
  'dashboard.ops.queueByStage.annotation': 'सबसे पुराना {age}',
  'dashboard.ops.trend.title': 'आवेदन और जारी किए गए कार्ड',
  'dashboard.ops.trend.subtitle': 'पिछले 30 दिन',
  'dashboard.ops.trend.series.submissions': 'आवेदन',
  'dashboard.ops.trend.series.issued': 'जारी किए गए कार्ड',
  'dashboard.ops.tierMix.title': 'जोखिम स्तर मिश्रण',
  'dashboard.ops.tierMix.subtitle': 'इस सीज़न के सभी आवेदनों में निष्कर्षों की गंभीरता',
  'dashboard.ops.tierMix.green': 'हरा',
  'dashboard.ops.tierMix.amber': 'अंबर',
  'dashboard.ops.tierMix.red': 'लाल',
  'dashboard.ops.evaluators.title': 'मूल्यांकनकर्ता अनुसार मूल्यांकन',
  'dashboard.ops.evaluators.subtitle': 'प्रति मूल्यांकनकर्ता पास / फेल विभाजन',
  'dashboard.ops.evaluators.series.pass': 'पास',
  'dashboard.ops.evaluators.series.fail': 'फेल',
  'dashboard.ops.evaluators.empty': 'अभी तक कोई मूल्यांकन दर्ज नहीं हुआ।',
  'dashboard.ops.findings.title': 'सबसे सामान्य निष्कर्ष',
  'dashboard.ops.findings.subtitle': 'विफल नियम जांच, आवृत्ति के अनुसार क्रमबद्ध',
  'dashboard.ops.findings.empty': 'अभी तक कोई विफल निष्कर्ष दर्ज नहीं हुआ।',
  'dashboard.ops.viewInQueue': 'कतार में देखें',

  'dashboard.season.tile.pilots': 'पंजीकृत पायलट',
  'dashboard.season.tile.cardsActive': 'सक्रिय कार्ड',
  'dashboard.season.tile.nationality': 'भारतीय बनाम विदेशी',
  'dashboard.season.tile.countries': 'प्रतिनिधित्व करने वाले देश',
  'dashboard.season.tile.avgApproval': 'औसत स्वीकृति समय',
  'dashboard.season.nationality.indian': 'भारतीय',
  'dashboard.season.nationality.foreign': 'विदेशी',
  'dashboard.season.byWeek.title': 'साप्ताहिक पंजीकरण',
  'dashboard.season.byWeek.subtitle': 'ISO सप्ताह अनुसार दाखिल किए गए आवेदन',
  'dashboard.season.topNationalities.title': 'शीर्ष राष्ट्रीयताएं',
  'dashboard.season.topNationalities.subtitle': 'इस सीज़न के आवेदनों की संख्या अनुसार',
  'dashboard.season.byState.title': 'चरण अनुसार आवेदन',
  'dashboard.season.byState.subtitle': 'हर कार्यप्रवाह चरण में वर्तमान मिश्रण',
  'dashboard.season.summary.title': 'सीज़न सारांश',
  'dashboard.season.summary.text':
    'इस सीज़न में अब तक {countries} देशों से {pilots} पायलट पंजीकृत हो चुके हैं; {active} के पास सक्रिय कार्ड है; औसत स्वीकृति {hours} घंटे में हुई।',
  'dashboard.season.summary.textNoApproval':
    'इस सीज़न में अब तक {countries} देशों से {pilots} पायलट पंजीकृत हो चुके हैं; {active} के पास सक्रिय कार्ड है।',
  'dashboard.season.downloadCsv': 'सीज़न रिपोर्ट डाउनलोड करें (CSV)',
  'dashboard.season.print': 'प्रिंट करें',

  // ── सार्वजनिक आंकड़े पृष्ठ (WP9, बिना लॉगिन, कोई व्यक्तिगत डेटा नहीं) ───
  'stats.eyebrow': 'सार्वजनिक आंकड़े',
  'stats.hero.title': 'बीर बिलिंग में {season}',
  'stats.hero.lede': 'इस सीज़न के Free Flyer Card पंजीकरण का एक सार्वजनिक, बिना-लॉगिन दृश्य — रजिस्टर से अद्यतन, बिना किसी व्यक्तिगत डेटा के।',
  'stats.hero.pilots': 'पंजीकृत पायलट',
  'stats.hero.cardsActive': 'सक्रिय कार्ड',
  'stats.hero.countries': 'प्रतिनिधित्व करने वाले देश',
  'stats.byWeek.title': 'साप्ताहिक पंजीकरण',
  'stats.byWeek.subtitle': 'इस सीज़न, ISO सप्ताह अनुसार दाखिल किए गए आवेदन',
  'stats.nationalities.title': 'पायलट कहां से आते हैं',
  'stats.nationalities.subtitle': 'इस सीज़न की शीर्ष 10 राष्ट्रीयताएं',
  'stats.nationalities.other': 'अन्य',
  'stats.how.title': 'यह कैसे काम करता है',
  'stats.how.body': 'हर पायलट बीर बिलिंग में व्यक्तिगत रूप से, पहचान-जांचा हुआ पंजीकरण पूरा करता है और SDM कार्यालय की स्वीकृति मिलने पर उसे Free Flyer Card मिलता है।',
  'stats.how.aboutLink': 'BirFlyPermit के बारे में',
  'stats.how.verifyLink': 'कार्ड सत्यापित करें',
  'stats.methodology': 'केवल कुल आंकड़े, रजिस्टर से अद्यतन। इस पृष्ठ पर कोई व्यक्तिगत डेटा न तो दिखाया जाता है, न संग्रहीत।',
  'stats.asOf': '{time} तक की स्थिति',
  'stats.source.live': 'रजिस्टर से लाइव',
  'stats.source.fallback': 'अंतिम प्रकाशित स्नैपशॉट दिखाया जा रहा है ({time})',
  'stats.share.title': 'इस पृष्ठ को साझा करें',
  'stats.share.copy': 'लिंक कॉपी करें',
  'stats.share.copied': 'लिंक कॉपी हो गया',
  'stats.share.share': 'साझा करें',
  'stats.error.title': 'आंकड़े लोड नहीं हो सके',
  'stats.error.retry': 'फिर से प्रयास करें',

  // ── निष्कर्ष नियम लेबल (सरल भाषा; rule id → लेबल; डैशबोर्ड "शीर्ष निष्कर्ष" में प्रयुक्त) ──
  'findings.rule.arrival.plausible': 'आगमन तिथि असंभावित',
  'findings.rule.cert.expiry': 'प्रमाणन समाप्त',
  'findings.rule.cert.holder': 'प्रमाणपत्र धारक बेमेल',
  'findings.rule.cert.recognised': 'प्रमाणन संस्था मान्यता प्राप्त नहीं',
  'findings.rule.declaration.complete': 'घोषणापत्र अधूरा',
  'findings.rule.dob.plausible': 'जन्मतिथि असंभावित',
  'findings.rule.doc.blocklist': 'दस्तावेज़ ब्लॉकलिस्ट में',
  'findings.rule.doc.duplicate': 'डुप्लिकेट दस्तावेज़',
  'findings.rule.doc.expiry': 'पहचान दस्तावेज़ समाप्त',
  'findings.rule.emergency.distinct': 'आपातकालीन संपर्क अलग नहीं',
  'findings.rule.glider.class': 'ग्लाइडर श्रेणी बेमेल',
  'findings.rule.glider.known': 'ग्लाइडर मान्यता प्राप्त नहीं',
  'findings.rule.ins.covers': 'बीमा कवर अपर्याप्त',
  'findings.rule.ins.validity': 'बीमा वैध नहीं',
  'findings.rule.medical.validity': 'चिकित्सा फिटनेस वैध नहीं',
  'findings.rule.mrz.checkdigits': 'MRZ चेक अंक विफल',
  'findings.rule.mrz.format': 'MRZ प्रारूप अमान्य',
  'findings.rule.name.match': 'नाम बेमेल',
  'findings.rule.phone.format': 'फ़ोन नंबर प्रारूप अमान्य',
  'findings.rule.visa.covers': 'वीज़ा प्रवास अवधि को कवर नहीं करता',
  'findings.rule.photo.quality': 'फ़ोटो गुणवत्ता समस्या',

  // ── जारी करना (WP8: /issue) ──────────────────────────────────────────────
  'issue.eyebrow': 'जारी करना',
  'issue.title': 'फ्री फ्लायर कार्ड जारी करें',
  'issue.description': 'स्वीकृत आवेदन को एक क्लिक में हस्ताक्षरित, प्रिंट-योग्य कार्ड में बदलें।',
  'issue.tab.key': 'कार्यालय कुंजी',
  'issue.tab.cards': 'कार्ड जारी करें',
  'issue.tab.sheet': 'प्रिंट शीट',
  'issue.tab.revocations': 'निरस्तीकरण',
  'issue.keyNotReady.title': 'कार्यालय की हस्ताक्षर कुंजी अभी सेट नहीं है',
  'issue.keyNotReady.body': 'अपने एडमिन से कहें कि वे कार्यालय कुंजी खोलकर इसे एक बार सेट करें। उसके बाद कार्ड अपने-आप हस्ताक्षरित होंगे।',
  'issue.cards.action.confirmAndIssue': 'पुष्टि करें और जारी करें',
  'issue.cards.modal.issuing': 'कार्ड जारी हो रहा है…',
  'issue.cards.field.cardNo': 'कार्ड नंबर',
  'issue.cards.field.validFrom': 'से मान्य',
  'issue.cards.field.validTo': 'तक मान्य',
  'issue.cards.field.name': 'नाम',
  'issue.cards.field.season': 'सीज़न के लिए मान्य',
  'issue.cards.batch.confirmTitle': 'सभी कार्ड जारी करें',
  'issue.cards.batch.confirmBody': 'अभी {count} कार्ड जारी करें? हर कार्ड हस्ताक्षरित होगा और इसे वापस नहीं लिया जा सकता।',
  'issue.cards.batch.confirmAction': '{count} कार्ड जारी करें',
  'issue.revocations.action.publish': 'निरस्तीकरण सूची प्रकाशित करें',
  'issue.office.status.title': 'कार्यालय की हस्ताक्षर कुंजी',
  'issue.office.status.ready': 'तैयार — कुंजी {kid}',
  'issue.office.status.notReady': 'सेट नहीं है',
  'issue.office.status.description': 'कार्ड कार्यालय की कुंजी से अपने-आप हस्ताक्षरित होते हैं, जो सर्वर पर सुरक्षित रहती है। कार्ड जारी करने के लिए किसी को कुछ खोलने की ज़रूरत नहीं है।',
  'issue.office.keys.title': 'कुंजियाँ',
  'issue.office.keys.none': 'अभी कोई कुंजी नहीं है। नीचे "कार्यालय कुंजी सेट करें" का उपयोग करें।',
  'issue.office.col.name': 'कुंजी का नाम',
  'issue.office.col.created': 'बनाई गई',
  'issue.office.col.status': 'स्थिति',
  'issue.office.badge.active': 'सक्रिय',
  'issue.office.badge.signs': 'कार्ड पर हस्ताक्षर करती है',
  'issue.office.badge.trusted': 'सत्यापन ऐप द्वारा विश्वसनीय',
  'issue.office.notTrusted': 'इंजीनियर से कहें कि इस कुंजी को सत्यापन ऐप (config/tenant.json) में जोड़कर दोबारा डिप्लॉय करें, वरना कार्ड सत्यापित नहीं होंगे।',
  'issue.office.actions.title': 'कुंजी की कार्रवाइयाँ',
  'issue.office.action.setup': 'कार्यालय कुंजी सेट करें',
  'issue.office.action.backupAgain': 'पेपर बैकअप दोबारा प्रिंट करें',
  'issue.office.action.restore': 'पेपर बैकअप से बहाल करें',
  'issue.office.action.downloadBackup': 'पेपर बैकअप डाउनलोड करें (PDF)',
  'issue.office.setup.title': 'कार्यालय कुंजी सेट करें',
  'issue.office.setup.confirm': 'इससे नई कार्यालय हस्ताक्षर कुंजी बनेगी और वही सक्रिय होगी। पेपर बैकअप केवल एक बार दिखाया जाएगा, इसलिए प्रिंटर तैयार रखें। जारी रखें?',
  'issue.office.setup.done': 'कार्यालय कुंजी बन गई।',
  'issue.office.backup.title': 'पेपर बैकअप दोबारा प्रिंट करें',
  'issue.office.backup.confirm': 'पेपर बैकअप से कार्यालय के नाम पर कार्ड पर हस्ताक्षर किए जा सकते हैं। तभी जारी रखें जब आप इसे प्रिंट करके सुरक्षित रखेंगे। यह अनुरोध दर्ज किया जाता है।',
  'issue.office.backup.shownTitle': 'कुंजी {kid} का पेपर बैकअप',
  'issue.office.backup.note': 'दो प्रतियाँ प्रिंट करें, उन्हें सील करें, और एक SDM की तिजोरी में रखें। कुंजी वापस पाने का यही एकमात्र तरीका है।',
  'issue.office.restore.title': 'पेपर बैकअप से बहाल करें',
  'issue.office.restore.help': 'पेपर बैकअप का पाठ लिखें और कुंजी को एक नाम दें।',
  'issue.office.restore.field.text': 'पेपर बैकअप का पाठ',
  'issue.office.restore.confirm': 'इससे कुंजी सर्वर पर वापस आ जाएगी और सक्रिय हो जाएगी। जारी रखें?',
  'issue.office.restore.fillAll': 'कुंजी का नाम और पेपर बैकअप का पाठ दर्ज करें।',
  'issue.office.restore.done': 'कुंजी बहाल हो गई।',
  'settings.config.key_id.hint': 'सामान्यतः अपने-आप सेट होती है। केवल इंजीनियर की सलाह पर बदलें।',
  'case.documents.pages': '{label} · {count} पृष्ठ',
  'case.documents.pageOf': 'पृष्ठ {n} / {total}',


  'issue.cards.empty.title': 'जारी करने के लिए कुछ नहीं',
  'issue.cards.empty.body': 'अभी कोई स्वीकृत आवेदन कार्ड की प्रतीक्षा में नहीं है।',
  'issue.cards.count': '{count} स्वीकृत आवेदन',
  'issue.cards.action.issueAll': 'सभी जारी करें ({count})',
  'issue.cards.action.issue': 'जारी करें',
  'issue.cards.action.printCard': 'यह कार्ड प्रिंट करें',
  'issue.cards.batch.progress': '{total} में से {done} जारी हुए',
  'issue.cards.batch.done': 'बैच जारी करना पूर्ण हुआ।',
  'issue.cards.modal.title': 'कार्ड जारी करें',
  'issue.cards.modal.confirmHelp': 'जारी करने से पहले इन विवरणों को आवेदन से मिलाएँ — जारी करना वापस नहीं लिया जा सकता।',
  'issue.cards.issueSuccess': 'कार्ड {cardNo} जारी हुआ।',
  'issue.cards.addedToSheet': 'प्रिंट शीट में जोड़ा गया',

  'issue.printSheet.description': 'जारी किए गए लेकिन अभी तक न छपे कार्ड। शामिल करने के लिए चुनें, फिर 8-अप A4 शीट डाउनलोड करें।',
  'issue.printSheet.empty.title': 'प्रिंट करने के लिए कुछ नहीं',
  'issue.printSheet.empty.body': 'हर जारी किया गया कार्ड पहले ही छप चुका है।',
  'issue.printSheet.action.download': 'प्रिंट शीट डाउनलोड करें ({count})',
  'issue.printSheet.action.markPrinted': 'इन्हें छपा हुआ चिह्नित करें ({count})',
  'issue.printSheet.downloaded': 'प्रिंट शीट {sheetId} डाउनलोड हुई।',
  'issue.printSheet.markHelp': 'शीट सही तरीके से छपने के बाद, इन कार्डों को छपा हुआ चिह्नित करें ताकि ये सूची से हट जाएं।',
  'issue.printSheet.markedPrinted': '{count} कार्ड छपे हुए चिह्नित किए गए।',

  'issue.revocations.published.title': 'वर्तमान में प्रकाशित',
  'issue.revocations.published.none': 'अभी तक कोई निरस्तीकरण सूची प्रकाशित नहीं हुई है।',
  'issue.revocations.draft.title': 'नई सूची बनाएं और प्रकाशित करें',
  'issue.revocations.draft.description': 'रजिस्टर से निरस्त कार्डों की वर्तमान सूची का मसौदा बनाता है। उसे जाँचें, फिर प्रकाशित करें — सूची अपने-आप हस्ताक्षरित होती है।',
  'issue.revocations.draft.adminOnly': 'केवल एडमिन ही निरस्तीकरण सूची प्रकाशित कर सकता है।',
  'issue.revocations.action.buildDraft': 'ड्राफ़्ट बनाएं',
  'issue.revocations.field.version': 'संस्करण',
  'issue.revocations.field.generatedAt': 'जनरेट हुआ',
  'issue.revocations.field.age': 'आयु',
  'issue.revocations.field.count': 'निरस्त कार्ड',
  'issue.revocations.field.signingKey': 'हस्ताक्षर कुंजी',
  'issue.revocations.ageHours': '{hours} घंटे पुराना',
  'issue.revocations.ageMinutes': '{minutes} मिनट पुराना',
  'issue.revocations.publishSuccess': 'निरस्तीकरण सूची प्रकाशित हुई।',
  'issue.revocations.instructions.title': 'यह /verify तक कैसे पहुंचती है',
  'issue.revocations.instructions.body':
    'साइट पर स्थिर revocations.json रात्रिकालीन जॉब/डिप्लॉय द्वारा ताज़ा की जाती है। /verify पृष्ठ जब भी सिग्नल मिलता है तो बैकएंड से सीधे नवीनतम सूची भी प्राप्त करता है, और ऑफ़लाइन होने पर हमेशा अपनी आखिरी डाउनलोड की गई सूची पर वापस चला जाता है।',

  // ── सत्यापन (WP8: /verify) ────────────────────────────────────────────────
  'verify.eyebrow': '{cardName} · {site}',
  'verify.title': 'फ्री फ्लायर कार्ड सत्यापित करें',
  'verify.description': 'जांचने के लिए प्रिंटेड कार्ड पर मौजूद QR स्कैन करें — यह बिना सिग्नल के भी काम करता है।',
  'verify.camera.error': 'कैमरा शुरू नहीं हो सका।',
  'verify.camera.unavailable': 'इस डिवाइस पर कैमरा उपलब्ध नहीं है — इसके बजाय नीचे दिए गए विकल्पों का उपयोग करें।',
  'verify.clockWarning': 'इस डिवाइस की घड़ी गलत लग रही है — तारीखों से जुड़े परिणाम अविश्वसनीय हो सकते हैं।',
  'verify.list.age': 'निरस्तीकरण सूची: {age}',
  'verify.list.loading': 'निरस्तीकरण सूची लोड हो रही है…',
  'verify.torch.on': 'टॉर्च चालू करें',
  'verify.torch.off': 'टॉर्च बंद करें',
  'verify.fallback.title': 'कार्ड QR टेक्स्ट टाइप या पेस्ट करें',
  'verify.fallback.label': 'QR टेक्स्ट',
  'verify.fallback.hint': 'यदि कैमरा इसे स्कैन नहीं कर सकता, तो QR के नीचे छपा सटीक टेक्स्ट टाइप या पेस्ट करें।',
  'verify.fallback.action': 'जांचें',
  'verify.lookup.title': 'कार्ड नंबर दर्ज करें',
  'verify.lookup.help': 'QR के बिना यह केवल निरस्तीकरण सूची जांच सकता है — यह कार्ड के असली या अवैध-समाप्ति-रहित होने की पुष्टि नहीं कर सकता।',
  'verify.lookup.action': 'खोजें',
  'verify.lookup.revoked': 'इस कार्ड नंबर को निरस्त कर दिया गया है।',
  'verify.lookup.cannotConfirm': 'निरस्तीकरण सूची में नहीं है — लेकिन QR स्कैन किए बिना यह कार्ड के असली या अवैध-समाप्ति-रहित होने की पुष्टि नहीं कर सकता।',
  'verify.settings.geo': 'स्कैन के साथ स्थान रिकॉर्ड करें',
  'verify.settings.sound': 'ध्वनि',
  'verify.settings.mute': 'ध्वनि म्यूट करें',
  'verify.settings.unmute': 'ध्वनि अनम्यूट करें',
  'verify.pendingScans': '{count} स्कैन अपलोड की प्रतीक्षा में',
  'verify.install.hint': 'ऑफ़लाइन उपयोग के लिए इस पृष्ठ को इंस्टॉल करें — इंस्टॉल होने पर यह बिना सिग्नल के भी काम करता है।',
  'verify.install.action': 'इंस्टॉल करें',
  'verify.offlineNote': 'लोड होने के बाद यह पृष्ठ बिना सिग्नल के भी काम करता रहता है।',
  'verify.badge.green': 'मान्य',
  'verify.badge.amber': 'चेतावनी',
  'verify.badge.red': 'अमान्य',
  'verify.result.validTo': '{date} तक मान्य',
  'verify.result.comparePhoto': 'प्रिंटेड कार्ड की फ़ोटो की सामने खड़े व्यक्ति से तुलना करें।',
  'verify.result.loadPhoto': 'फ़ोटो लोड करें',
  'verify.result.scanNext': 'अगला स्कैन करें',
  'verify.card.signedBy': '{authority} द्वारा हस्ताक्षरित · इस डिवाइस पर ऑफ़लाइन सत्यापित',
  'verify.card.doNotAccept': 'इस कार्ड को स्वीकार न करें',
  'verify.card.photoPlaceholder': 'प्रिंटेड फ़ोटो से मिलान करें',
  'verify.card.nationality': 'राष्ट्रीयता',
  'verify.card.certification': 'प्रमाणन',
  'verify.card.validity': 'वैधता',
  'verify.card.validFrom': 'से',
  'verify.card.validTo': 'तक',
  'verify.card.daysLeft': '{n} दिन शेष',
  'verify.card.dayLeft': '1 दिन शेष',
  'verify.card.expiresToday': 'आज समाप्त हो रहा है',
  'verify.card.expiredAgo': '{n} दिन पहले समाप्त हुआ',
  'verify.card.expiredYesterday': 'कल समाप्त हुआ',
  'verify.card.insurance': 'बीमा',
  'verify.card.insurer': 'बीमाकर्ता',
  'verify.card.policyNo': 'पॉलिसी नंबर',
  'verify.card.insuranceValidTo': 'तक मान्य',
  'verify.card.cover': 'कवरेज',
  'verify.card.more': 'और देखें',
  'verify.card.less': 'कम देखें',
  'verify.card.emergency': 'आपातकालीन संपर्क',
  'verify.card.name': 'नाम',
  'verify.card.relationship': 'संबंध',
  'verify.card.phone': 'फ़ोन',
  'verify.card.call': 'कॉल करें',
  'verify.card.glider': 'ग्लाइडर',
  'verify.card.gliderModel': 'मॉडल',
  'verify.card.gliderClass': 'EN श्रेणी',
  'verify.card.pilot': 'पायलट',
  'verify.card.dob': 'जन्म तिथि',
  'verify.card.bloodGroup': 'रक्त समूह',
  'verify.card.radioFrequency': 'रेडियो फ़्रीक्वेंसी',
  'verify.card.residence': 'निवास का देश',
  'verify.card.office': 'जारी करने वाला कार्यालय',
  'verify.card.officeAddress': 'पता',
  'verify.card.officeEmail': 'ई-मेल',
  'verify.card.officeWhatsapp': 'व्हाट्सऐप',
  'verify.card.grievance': 'शिकायत अधिकारी',
  'verify.card.footerKey': 'कुंजी {kid}',
  'verify.card.footerIssued': 'जारी: {date}',
  'verify.card.loading': 'बीमा और संपर्क विवरण लोड हो रहे हैं…',
  'verify.card.offlineNote': 'बीमा और संपर्क विवरण देखने के लिए इंटरनेट से जुड़ें।',
  'verify.card.revokedOn': 'रजिस्टर के अनुसार यह कार्ड {date} को रद्द किया गया था।',
  'status.card.openVerified': 'मेरा सत्यापित कार्ड खोलें',

  // ── स्टाफ़ साइन इन ──────────────────────────────────────────────────────────
  'login.eyebrow': 'स्टाफ़',
  'login.title': 'साइन इन करें',
  'login.description': 'एसडीएम बैजनाथ कार्यालय के स्टाफ़ के लिए — पायलटों को खाते की आवश्यकता नहीं है।',
  'login.field.user': 'उपयोगकर्ता',
  'login.field.passphrase': 'पासफ़्रेज़',
  'login.field.showPassphrase': 'दिखाएं',
  'login.field.hidePassphrase': 'छिपाएं',
  'login.field.showPassphraseAria': 'पासफ़्रेज़ दिखाएं',
  'login.field.hidePassphraseAria': 'पासफ़्रेज़ छिपाएं',
  'login.submit': 'साइन इन करें',
  'login.submitting': 'साइन इन हो रहा है…',
  'login.signedInAs': '{name} के रूप में साइन इन किया',
  'login.error.generic': 'साइन इन नहीं हो सका। अपना कनेक्शन जांचें और फिर से प्रयास करें।',
  'login.demo.title': 'डेमो खाते',
  'login.demo.badge': 'डेमो बिल्ड',
  'login.demo.intro': 'यह बिल्ड पूरी तरह से आपके ब्राउज़र में नमूना डेटा के साथ चलता है। पासफ़्रेज़ {passphrase} का उपयोग करके इनमें से किसी से भी साइन इन करें:',

  // ── होम और परिचय (मार्केटिंग) ────────────────────────────────────────────────
  'home.eyebrow': '{office} · {district} जिला',
  'home.steps.register.title': 'ऑनलाइन पंजीकरण करें',
  'home.steps.register.body': 'कहीं से भी, अपने फ़ोन से अपना विवरण भरें।',
  'home.steps.checked.title': 'दस्तावेज़ तुरंत जांचे जाते हैं',
  'home.steps.checked.body': 'सबमिट करने से पहले ही गलतियाँ पकड़ ली जाती हैं।',
  'home.steps.evaluation.title': 'मूल्यांकन और एसडीएम स्वीकृति',
  'home.steps.evaluation.body': 'हमारी टीम और एसडीएम पुष्टि करते हैं कि आप उड़ान भर सकते हैं।',
  'home.steps.card.title': 'आपका {cardName}',
  'home.steps.card.body': 'एक हस्ताक्षरित QR जिसे आप दिखा सकते हैं — बिना सिग्नल के भी।',
  'home.needed.id': 'पासपोर्ट / फ़ोटो पहचान पत्र',
  'home.needed.photo': 'पासपोर्ट आकार की फ़ोटो',
  'home.needed.cert': 'पैराग्लाइडिंग प्रमाणन',
  'home.needed.insurance': 'पैराग्लाइडिंग को कवर करने वाला बीमा',
  'home.needed.glider': 'ग्लाइडर विवरण',
  'home.needed.emergency': 'आपातकालीन संपर्क',
  'home.season.cta': 'इस सीज़न के लिए पंजीकरण करें →',
  'home.trust.offline.title': 'ऑफ़लाइन-सत्यापन योग्य',
  'home.trust.offline.body': 'हर कार्ड में एक हस्ताक्षरित QR होता है जो बिना किसी सिग्नल के भी सही साबित होता है।',
  'home.trust.dataMin.title': 'न्यूनतम डेटा संग्रह',
  'home.trust.dataMin.body': 'हम केवल वही जानकारी लेते हैं जो आपको पंजीकृत करने और आपका कार्ड जारी करने के लिए आवश्यक है।',
  'home.trust.dpdp.title': 'डीपीडीपी सूचना',
  'home.trust.dpdp.link': 'हमारी गोपनीयता सूचना पढ़ें →',
  'home.statusCheck.title': 'मेरी स्थिति जांचें',
  'home.statusCheck.intro': 'अपनी पंजीकरण पुष्टि से संदर्भ संख्या और टोकन का उपयोग करें — या हमारे भेजे गए स्थिति लिंक को पेस्ट करें।',
  'home.statusCheck.linkLabel': 'स्थिति लिंक',
  'home.statusCheck.linkHint': 'पूरा लिंक पेस्ट करें — हम नीचे दिए गए फ़ील्ड अपने आप भर देंगे',
  'home.statusCheck.refLabel': 'संदर्भ संख्या',
  'home.statusCheck.tokenLabel': 'एक्सेस टोकन',
  'home.statusCheck.submit': 'स्थिति देखें',
  'home.statusCheck.needToken': 'अपने ई-मेल का एक्सेस टोकन दर्ज करें, या पूरा स्टेटस लिंक चिपकाएँ (जो ?t=… पर समाप्त होता है)।',
  'home.statusCheck.lost': 'ई-मेल खो गया?',
  'home.statusCheck.lostBody': 'अपना संदर्भ और पंजीकरण में दिया ई-मेल पता दर्ज करें — हम नया स्टेटस लिंक भेज देंगे।',
  'home.statusCheck.emailLabel': 'पंजीकरण में दिया ई-मेल पता',
  'home.statusCheck.resend': 'मुझे नया लिंक भेजें',
  'home.statusCheck.resent': 'यदि संदर्भ और ई-मेल मेल खाते हैं, तो नया लिंक भेज दिया गया है — Spam भी देखें।',
  'home.heroArt.alt': 'धौलाधार पर्वतमाला के ऊपर उड़ते पैराग्लाइडर, बीड़ बिलिंग',

  'about.eyebrow': '{district} जिला · {state}',
  'about.title': '{name} के बारे में',
  'about.description': '{name}, {site} में आने वाले पैराग्लाइडर पायलटों के लिए डिजिटल {cardName} रजिस्ट्री है, जिसे {authority} के लिए बनाया गया है।',
  'about.howItWorks': 'यह कैसे काम करता है',
  'about.steps.register.title': 'ऑनलाइन पंजीकरण करें',
  'about.steps.register.body': 'अपने फ़ोन से अपना विवरण, दस्तावेज़, प्रमाणन, ग्लाइडर और बीमा भरें — शुरू करने के लिए कार्यालय जाने की ज़रूरत नहीं।',
  'about.steps.checked.title': 'दस्तावेज़ तुरंत जांचे जाते हैं',
  'about.steps.checked.body': 'आपके दस्तावेज़ नंबर, तारीखें और प्रमाणन टाइप करते ही जांचे जाते हैं, ताकि सबमिट करने से पहले ही गलतियाँ पकड़ी जा सकें।',
  'about.steps.evaluation.title': 'मूल्यांकन और एसडीएम स्वीकृति',
  'about.steps.evaluation.body': 'हमारी टीम सीज़न के नियमों के अनुसार आपके प्रमाणन और ग्लाइडर श्रेणी की पुष्टि करती है; एसडीएम आवेदन को स्वीकृति देते हैं।',
  'about.steps.card.title': 'आपका {cardName}',
  'about.steps.card.body': 'आपको एक हस्ताक्षरित QR कोड वाला कार्ड मिलता है, जिसे लॉन्च साइट पर, कागज़ पर या आपके फ़ोन पर ऑफ़लाइन सत्यापित किया जा सकता है।',
  'about.whatYouNeed': 'आपको क्या चाहिए',
  'about.needed.id': 'पासपोर्ट या अन्य फ़ोटो पहचान पत्र',
  'about.needed.photo': 'पासपोर्ट आकार की फ़ोटो',
  'about.needed.cert': 'आपका पैराग्लाइडिंग प्रमाणन',
  'about.needed.insurance': 'पैराग्लाइडिंग को कवर करने वाला बीमा',
  'about.needed.glider': 'आपके ग्लाइडर का मेक, मॉडल और श्रेणी',
  'about.needed.emergency': 'एक आपातकालीन संपर्क',
  'about.yourData': 'आपका डेटा',
  'about.privacy.title': 'डिजिटल व्यक्तिगत डेटा सुरक्षा अधिनियम के तहत न्यूनतम डेटा संग्रह',
  'about.privacy.body1':
    'हम केवल वही जानकारी लेते हैं जो आपकी उड़ान पात्रता जांचने और आपका कार्ड जारी करने के लिए ज़रूरी है: आपका पहचान दस्तावेज़, प्रमाणन, ग्लाइडर और बीमा विवरण, और एक आपातकालीन संपर्क। आपके दस्तावेज़ का उपयोग केवल आपकी पहचान सत्यापित करने के लिए किया जाता है और इसे प्रकाशित नहीं किया जाता; आपके कार्ड पर केवल आपका नाम, राष्ट्रीयता, प्रमाणन और एक कार्ड नंबर दिखाई देता है।',
  'about.privacy.body2':
    'नियामक और सुरक्षा उद्देश्यों के लिए डेटा {years} वर्षों तक रखा जाता है, और आप नीचे दिए गए शिकायत अधिकारी को लिखकर पूछ सकते हैं कि हमारे पास आपके बारे में क्या जानकारी है या सुधार का अनुरोध कर सकते हैं।',
  'about.contact': 'संपर्क करें',
  'about.grievanceOfficer': 'शिकायत अधिकारी: {officer}',
  'about.builtFor': '{authority} के लिए बनाया गया।',
};
